<template>
    <div id="canvas-frame-element">
      <ProjectStructureBuildingModelNew @hook:mounted="$nextTick(() => {
        $store.dispatch('Ultra/requestUObject', {
          url: [
            { projects: parseInt(project_id) },
            { projectstructure: '' }
          ],
        }).then(() => {
          requestProjectElements(project_id).then(() => {
            loading_structure = false;
            initializeScene()
          })
        });
      })">
  
        <canvas id="three-canvas" class="hp-canvas-bckgrnd"></canvas>
  
  
        <div class="hp-content-struct d-block flex-column align-content-between ">
  
          <!-- Struct Header Bereich -->
          <div class="struct-content-top hp-top-bar d-flex flex-row align-content-between">
  
            <!-- Struct Mode Switchh -->
            <div class="hp-mode-switch d-flex align-items-start">
              <v-menu offset-y>
                <template v-slot:activator="{ on: menu }">
  
                  <v-tooltip bottom style="z-index: 20;" id="hp-element-background" color="rgba(30, 28, 45, 0.7)">
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn class="hp-toggle-background text-left" id="hp-element-background"
                        v-on="{ ...tooltip, ...menu }" width="300">
                        <TIcon :name="active_struct_mode.icon" style="font-size: auto;" />
                        {{ active_struct_mode.title }}
                      </v-btn>
                    </template>
                    <div class="d-flex flex-row" style="width: 200px;">
                      <TIcon :name="active_struct_mode.icon" style="width: 50px;" />
  
                      <div class="d-flex flex-column ">
                        {{ active_struct_mode.title }}
                        <span class="font-weight-light" style="font-size: 12px;">{{ active_struct_mode.text }}</span>
                        <span>{{ active_struct_mode.shortcut }}</span>
                      </div>
  
                    </div>
                  </v-tooltip>
  
                </template>
  
  
                <v-list class="hp-blur-background">
                  <v-list-item v-for="(struct_mode, index) in struct_modes" :key="index" @click="btnTitle(index)">
                    <v-tooltip bottom style="z-index: 20;" id="hp-element-background" color="rgba(30, 28, 45, 0.7)">
                      <template v-slot:activator="{ on: tooltip }">
  
                        <div v-on="{ ...tooltip }" class="d-flex flex-row">
                          <TIcon :name="struct_mode.icon" style="font-size: auto;" />
                          <v-list-item-title>{{ struct_mode.title }}</v-list-item-title>
                        </div>
                      </template>
  
                      <div class="d-flex flex-row" style="width: 200px;">
                        <TIcon :name="active_struct_mode.icon" style="width: 50px;" />
  
                        <div class="d-flex flex-column ">
                          {{ struct_mode.title }}
                          <span class="font-weight-light" style="font-size: 12px;">{{ struct_mode.text }}</span>
                          <span>{{ struct_mode.shortcut }}</span>
                        </div>
  
                      </div>
                    </v-tooltip>
  
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <!-- Struct Mode Switchh End-->
  
  
            <div class="struct-content-center d-flex align-items-center justify-content-center">
              hallo
            </div>
  
            <!-- Global Filter Dialog-->
            <div class="hp-global-filter d-flex align-items-end">
  
  
              <v-dialog v-model="global_filter_dialog" persistent width="auto" style="z-index: 5;">
                <template v-slot:activator="{ global_filter_open }">
                  <v-btn v-bind="global_filter_open" @click="global_filter_dialog = true" class="d-flex text-left"
                    id="hp-element-background">
                    global Filter
                  </v-btn>
                </template>
  
                <v-card class="struct-global-filter  hp-color-drk-b06 d-flex flex-column ">
  
                  <v-card-title>
                    <span class="text-h5">Global Filter</span>
                    <v-spacer></v-spacer>
                    <v-btn density="comfortable" icon color="white" @click="global_filter_dialog = false">
                      <TIcon name="close" />
                    </v-btn>
                  </v-card-title>
  
  
                  <v-container class="global_filter_content flex-fill">
                    <v-row class="global_filter_content m-0 ">
                      <div class="global_filter_tree d-flex flex-fill">
                        <v-card class="flex-fill" id="hp-element-background">
                          <v-tabs v-model="global_filter_tab" bg-color="primary">
                            <v-tab value="global_ifc">IFC</v-tab>
                            <v-tab value="global_process">Process</v-tab>
                            <v-tab value="global_selection">Selection</v-tab>
                            <v-tab value="global_linked">Linked</v-tab>
                            <v-tab value="global_unlinked">Not Linked</v-tab>
                            <v-tab value="global_visible">Only Visible</v-tab>
                          </v-tabs>
  
                          <v-card-text>
                            <v-window v-model="global_filter_tab">
                              <v-window-item value="global_ifc">
                                One
                              </v-window-item>
  
                              <v-window-item value="global_process">
                                Two
                              </v-window-item>
  
                              <v-window-item value="global_selection">
                                Three
                              </v-window-item>
  
                              <v-window-item value="global_linked">
                                One
                              </v-window-item>
  
                              <v-window-item value="global_unlinked">
                                Two
                              </v-window-item>
  
                              <v-window-item value="global_visible">
                                Three
                              </v-window-item>
                            </v-window>
                          </v-card-text>
                        </v-card>
                      </div>
  
                      <div class="global_filter_packages d-flex " id="hp-element-background">
                        hi2
                      </div>
                    </v-row>
  
                  </v-container>
  
  
  
                  <v-card-text>
                    Do You want to connect the selected Elements to the selected WORK.Step?
                  </v-card-text>
                  <v-card-actions class="d-flex flex-end">
                    <v-spacer></v-spacer>
                    <v-btn color="blue-darken-1" variant="text" @click="global_filter_dialog = false">
                      Apply for Visibility
                    </v-btn>
                    <v-btn color="blue-darken-1" variant="text" @click="global_filter_dialog = false">
                      Apply to Selection
                    </v-btn>
                    <v-btn color="blue-darken-1" variant="text" @click="global_filter_dialog = false">
                      Link to TAKT.Area
                    </v-btn>
                    <v-btn color="blue-darken-1" variant="text" @click="global_filter_dialog = false">
                      Link to WORK.Step
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
            <!-- Global Filter Dialog-->
  
          </div>
          <!-- Struct Header Bereich End -->
  
  
          <!-- Struct main content Bereich -->
          <div class="d-flex struct-container flex-row">
  
            <!-- Struct linker main content Bereich, IFC Tree, Details -->
            <div class="d-flex struct-content-left align-items-start justify-content-start"
              style="width: calc(var(--project_structure_spatial_structure_details_width_l) * 1px);">
  
              <div class="d-flex struct-content-left-ifc flex-column align-items-start justify-content-start ">
                <div
                  class="d-flex struct-tree-ifc struct-tree hp-color-drk-b07 w-100 flex-column align-items-start justify-content-start"
                  style="height: calc(100% - ( var(--project_structure_spatial_structure_details_height_l) * 1px ));">
  
                  <div class="struct-tree-filter d-flex flex-row w-100">
  
                    <!-- IFC Layer Filter -->
                    <div>
                      <v-menu offset-y :close-on-content-click="false" v-model="menu_layer_filter_ifc">
                        <template v-slot:activator="{ on: menu_layer_filter_ifc }">
  
                          <v-tooltip bottom style="z-index: 20;" id="hp-element-background" color="rgba(30, 28, 45, 0.7)">
                            <template v-slot:activator="{ on: tooltip }">
                              <v-btn class="hp-toggle-background d-flex struct-tree-filter-btn" id="hp-element-background"
                                v-on="{ ...tooltip, ...menu_layer_filter_ifc }" width="300">
                                <TIcon name="properties" style="font-size: auto;" />
                                <TIcon name="menu-down" />
                              </v-btn>
                            </template>
                            <span>IFC-Tree Layer Filter</span>
                          </v-tooltip>
  
                        </template>
  
  
                        <v-list class="hp-blur-background">
                          <v-card-title>
                            <span>IFC-Tree Layer Filter</span>
                            <v-spacer></v-spacer>
                            <v-btn density="comfortable" icon color="white" @click="menu_layer_filter_ifc = false">
                              <TIcon name="close" />
                            </v-btn>
                          </v-card-title>
  
                          <v-list-item v-for="(type, index) in $store.state.Ultra.ifc_wrapper" :key="index">
                            <v-tooltip bottom style="z-index: 20;" id="hp-element-background" color="rgba(30, 28, 45, 0.7)">
                              <template v-slot:activator="{ on: tooltip }">
  
                                <div v-on="{ ...tooltip }" class="d-flex flex-row">
  
                                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                                  <v-icon small color="rgba(255,255,255,0.7)" class="mx-2">{{ getElementsIcon(type.name)
                                  }}</v-icon>
                                  <v-list-item-title class="ml-2">{{ type.name }}</v-list-item-title>
                                </div>
                              </template>
  
                              <span>IFC-Tree Layer Filter</span>
  
                            </v-tooltip>
  
                          </v-list-item>
  
                          <v-card-actions>
                            <v-spacer></v-spacer>
  
                            <v-tooltip bottom style="z-index: 20;" id="hp-element-background" color="rgba(30, 28, 45, 0.7)">
                              <template v-slot:activator="{ on: tooltip }">
                                <v-btn density="comfortable" icon v-on="{ ...tooltip }">
                                  <TIcon name="restart" />
                                </v-btn>
                              </template>
                              <span>Refresh Filter</span>
                            </v-tooltip>
  
                            <v-tooltip bottom style="z-index: 20;" id="hp-element-background" color="rgba(30, 28, 45, 0.7)">
                              <template v-slot:activator="{ on: tooltip }">
                                <v-btn density="comfortable" icon v-on="{ ...tooltip }">
                                  <TIcon name="checkbox-radial-filled" />
                                </v-btn>
                              </template>
                              <span>Apply Filter</span>
                            </v-tooltip>
  
  
                          </v-card-actions>
  
  
                        </v-list>
                      </v-menu>
                    </div>
                    <!-- IFC Layer Filter End -->
  
                    <!-- IFC local view Filter -->
                    <div>
                      <v-menu offset-y :close-on-content-click="false" v-model="menu_view_filter_ifc">
                        <template v-slot:activator="{ on: menu_view_filter_ifc }">
  
                          <v-tooltip bottom style="z-index: 20;" id="hp-element-background" color="rgba(30, 28, 45, 0.7)">
                            <template v-slot:activator="{ on: tooltip }">
                              <v-btn class="hp-toggle-background d-flex struct-tree-filter-btn" id="hp-element-background"
                                v-on="{ ...tooltip, ...menu_view_filter_ifc }" width="300">
                                <TIcon name="bullet-list" style="font-size: auto;" />
                                <TIcon name="menu-down" />
                              </v-btn>
                            </template>
                            <span>IFC-Tree local view Filter</span>
                          </v-tooltip>
  
                        </template>
  
  
                        <v-list class="hp-blur-background">
                          <v-card-actions>
                            <span>IFC-Tree local view Filter</span>
                            <v-spacer></v-spacer>
                            <v-btn density="comfortable" icon color="white" @click="menu_view_filter_ifc = false">
                              <TIcon name="close" />
                            </v-btn>
                          </v-card-actions>
  
                          <v-list-item v-for="(local, index) in local_view_filter" :key="index">
                            <v-tooltip bottom style="z-index: 20;" id="hp-element-background" color="rgba(30, 28, 45, 0.7)">
                              <template v-slot:activator="{ on: tooltip }">
  
                                <div v-on="{ ...tooltip }" class="d-flex flex-row">
  
                                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                                  <v-list-item-title class="ml-2">{{ local.title }}</v-list-item-title>
                                </div>
                              </template>
  
                              <span>IFC-Tree local view Filter</span>
  
                            </v-tooltip>
  
                          </v-list-item>
  
  
                          <v-card-title>Sort IFC-Elements</v-card-title>
                          <v-btn-toggle v-model="toggle_mandatory" mandatory rounded="xl " size="x-small">
                            <v-btn v-for="(sort, index) in  local_sort_filter" :key="index" size="x-small"
                              @click="isUpwards != isUpwards && isDownwards != isDownwards">
                              {{ sort.title }}
                              <TIcon :name="sort.icon" />
                            </v-btn>
                          </v-btn-toggle>
  
                          <v-list-item v-for="(ifc_geometry_value, index) in  $store.state.Ultra.ifc_geometry_values"
                            :key="index">
                            <v-tooltip bottom style="z-index: 20;" id="hp-element-background" color="rgba(30, 28, 45, 0.7)">
                              <template v-slot:activator="{ on: tooltip }">
                                <div v-on="{ ...tooltip }" class="d-flex flex-row pl-3">
                                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                                  <v-card-text class="ml-1">{{ ifc_geometry_value.text }}</v-card-text>
                                </div>
                              </template>
                              <span>IFC-Tree local view Filter</span>
                            </v-tooltip>
                          </v-list-item>
  
  
                          <v-card-actions>
                            <v-spacer></v-spacer>
  
                            <v-tooltip bottom style="z-index: 20;" id="hp-element-background" color="rgba(30, 28, 45, 0.7)">
                              <template v-slot:activator="{ on: tooltip }">
                                <v-btn density="comfortable" icon v-on="{ ...tooltip }">
                                  <TIcon name="restart" />
                                </v-btn>
                              </template>
                              <span>Refresh Filter</span>
                            </v-tooltip>
  
                            <v-tooltip bottom style="z-index: 20;" id="hp-element-background" color="rgba(30, 28, 45, 0.7)">
                              <template v-slot:activator="{ on: tooltip }">
                                <v-btn density="comfortable" icon v-on="{ ...tooltip }">
                                  <TIcon name="checkbox-radial-filled" />
                                </v-btn>
                              </template>
                              <span>Apply Filter</span>
                            </v-tooltip>
  
  
                          </v-card-actions>
  
  
                        </v-list>
                      </v-menu>
                    </div>
                    <!-- IFC local view Filter End -->
  
  
  
  
  
                    <div class="d-flex struct-tree-filter-search flex-fill " id="hp-element-background">
                      <input type="text" placeholder="Search.." class="input_search">
                      <TIcon name="magnifying-glass" style="font-size: auto;" />
                    </div>
  
  
                    <div>
                      <v-btn class="d-flex struct-tree-filter-btn flex-end" id="hp-element-background">
                        <TIcon name="filter-inverted" style="font-size: auto;" />
                        <TIcon name="menu-down" />
                      </v-btn>
                    </div>
  
                  </div>
  
                  <div class="struct-tree-ifc-content d-flex pr-3" id="hp-element-background">
                    <div id="projectTree my-5 " class="d-flex projectTree">
  
                      <v-progress-circular v-if="loading_structure" indeterminate />
  
                      <!-- !!! Hier Herzstück von Project structure tree !!!-->
                      <ProjectStructureTree v-else style="padding-left: 24px; width: 100%;"
                        :isEditMode="isEditMode && select_spatial_el_ta_id === -1" :parent="project"
                        :child_elements="getChildElements({ parent_type: 'projects', parent_id: project_id })"
                        :selected_tree_element_ifc="selected_tree_element_ifc"
                        :all_selected_elements="getAllSelectedElements({ project_id: project_id })"
                        :train_selected_elements="select_spatial_el_train_id !== -1 ? getAllSelectedElements({ project_id: project_id, train_id: select_spatial_el_train_id }) : []"
                        :ta_selected_elements="select_spatial_el_ta_id !== -1 ? getUObject({ type: 'taktareas', id: select_spatial_el_ta_id }).elements : []"
                        :ta_hovered_elements="hover_ta_id !== -1 ? getUObject({ type: 'taktareas', id: hover_ta_id }).elements : (hover_train_id !== -1 ? getAllChildElements({ parent_type: 'trains', parent_id: hover_train_id }) : [])"
                        :select_spatial_el_ta_id="select_spatial_el_ta_id" :hover_el_ids="hover_el_ids"
                        :parent_color_index="3" :show_visibility="hasPermission('Upload IFC')" @toggleVisibility="setVisibleElements({
                            action: $event.result === 'visible' ? 'remove' : 'add',
                            element_ids: $event.element_ids
                          }), show_elements_by_takt = false
                          " @closeWrapper="$event.type === 'element_wrapper' ? toggleElementWrappersOpen($event) : updateUDObject({
        url: [
          { [$event.type]: $event.id },
        ],
        update: {
          closed: !$event.closed
        }
      })
      " @draggableUpdate="updateUObject({
        url: [
          { [$event.evt.item.id.split('#')[0]]: $event.evt.item.id.split('#')[1] },
        ],
        url_prefix: `/projects/${project_id}/projectstructure`,
        update: {
          order_index: ($event.evt.newIndex + ($event.evt.newIndex > $event.evt.oldIndex ? 1 : 0)) * 10 + 5
        },
      }).then(() => {
        updateTreeOrderIndex($event.parent)
      })
      " @draggableRemove="updateUObjectParent({
        url: [
          { [$event.evt.from.id.split('#')[0]]: parseInt($event.evt.from.id.split('#')[1]) },
          { [$event.evt.item.id.split('#')[0]]: parseInt($event.evt.item.id.split('#')[1]) },
          { changeparent: '' }
        ],
        url_prefix: `/projects/${project_id}/projectstructure`,
        update: {
          target_type: $event.evt.to.id.split('#')[0],
          target_id: parseInt($event.evt.to.id.split('#')[1]),
          parent: {
            type: $event.evt.to.id.split('#')[0],
            id: parseInt($event.evt.to.id.split('#')[1])
          }
        },
  
      }).then(() => {
        updateUObject({
          url: [
            { [$event.evt.item.id.split('#')[0]]: parseInt($event.evt.item.id.split('#')[1]) },
          ],
          url_prefix: `/projects/${project_id}/projectstructure`,
          update: {
            order_index: $event.evt.newIndex * 10 + 5,
            /* parent: {type: $event.evt.to.id.split('#')[0], id: $event.evt.to.id.split('#')[1]} */
          }
        }).then(() => {
          updateUDObject({
            url: [
              { [$event.evt.item.id.split('#')[0]]: parseInt($event.evt.item.id.split('#')[1]) },
            ],
            url_prefix: `/projects/${project_id}/projectstructure`,
            update: {
              parent: { type: $event.evt.to.id.split('#')[0], id: $event.evt.to.id.split('#')[1] }
            }
          }).then(() => {
            updateTreeOrderIndex($event.parent)
          })
        })
      })
      " @draggableAdd="updateTreeOrderIndex($event.parent)" @clickAddElement="createUObject({
        url: [
          { [$event.parent.type]: $event.parent.id },
          { [$event.element.type]: '' },
          { showWithEntitiesNormalized: '' }
        ],
        url_prefix: `/projects/${project_id}/projectstructure`,
        u_object: JSON.parse(JSON.stringify(Object.assign(ifc_entities[$event.element.type], { order_index: 5, parent: { type: $event.parent.type, id: $event.parent.id } })))
      }).then(() => {
        updateTreeOrderIndex($event.parent)
      })
      " @deleteTreeElement="$event.type === 'plans' ?
        deleteUDObject({
          url: [
            { [$event.parent.type]: $event.parent.id },
            { [$event.type]: $event.id }
          ],
          url_prefix: `/projects/${project_id}/projectstructure`,
        })
        :
        removeElementsFromTaktareas({
          type: $event.type,
          id: $event.id,
        }).then(() => {
          deleteUObject({
            url: [
              { [$event.parent.type]: $event.parent.id },
              { [$event.type]: $event.id }
            ],
            url_prefix: `/projects/${project_id}/projectstructure`,
          })
        })
      " @changeValue="updateUObject({
        url: [
          { [$event.element.type]: $event.element.id }
        ],
        url_prefix: `/projects/${project_id}/projectstructure`,
        update: {
          [$event.key]: $event.value
        }
      })
      " @addElement="addUObjects({
        url: [
          { projects: project_id },
          { trains: 0 },
          { taktareas: select_spatial_el_ta_id },
          { add: '' }
        ],
        u_objects: {
          target_type: 'elements',
          target_ids: [parseInt($event.id)]
        }
      })
      " @removeElement="removeUObjects({
        url: [
          { projects: project_id },
          { trains: 0 },
          { taktareas: select_spatial_el_ta_id },
          { remove: '' }
        ],
        u_objects: {
          target_type: 'elements',
          target_ids: [parseInt($event.id)]
        }
      })
      " @enterElement="elMouseEnter($event)" @leaveElement="elMouseLeave($event)"
                        @treeElementClicked="treeElementClicked($event)" />
  
                    </div>
  
                  </div>
                  <!-- !!! Hier Herzstück von Project structure tree !!! End-->
                </div>
  
                <!-- Hp !!! IFC Detail Fenster  -->
                <div class="d-flex flex-column struct-details"
                  style="height: calc(var(--project_structure_spatial_structure_details_height_l) * 1px);  overflow: auto; ">
  
                  <!-- Activator -->
                  <div class="d-flex struct-slider">
                    <ActivatorSlider style="position: relative; top: 4px; left: 50%;"
                      class="self-centered cursor-row-resize"
                      css_variable="--project_structure_spatial_structure_details_height_l" direction="y" />
                  </div>
  
  
                  <!-- Hp !!! Detail Fenster / sollte auch ein eigene Component ausgelagert werden-->
                  <div class="d-flex struct-details-ifc  pt-5" id="hp-element-background">
  
  
                    <transition name="dialog_slide" id="detailWindow">
                      <div
                        v-if="selected_tree_element_ifc.id !== -1 && !['trains', 'taktareas', 'taktareashapes'].includes(selected_tree_element_ifc.type)"
                        class="hp-color-drk-06 px-3 pa-1 word-wrap "
                        style="overflow: auto; overflow-wrap: break-word; width: 100%; padding-top: 60px;">
                        <!-- 
                        <v-icon>{{ getElementsIcon(selected_tree_element.type) }}</v-icon>
                        {{selected_tree_element.name}} 
                        <v-btn @click="selected_tree_element = { type: 'elements', id: -1 }" icon>
                          <v-icon>keyboard_arrow_down</v-icon>
                        </v-btn>
                        
                        <div class="d-flex flex-row-reverse">
                          <v-btn icon class="grey darken-5 ">
                            <v-icon
                              :color="getVisibility({ type: selected_tree_element.type, id: selected_tree_element.id, element_ids: selected_tree_element.type === 'element_wrapper' ? selected_tree_element.element_ids : [] }).color"
                              small @click.prevent.stop="setVisibleElements({
                                  action: getVisibility({ type: selected_tree_element.type, id: selected_tree_element.id, element_ids: selected_tree_element.type === 'element_wrapper' ? selected_tree_element.element_ids : [] }).result === 'visible' ? 'remove' : 'add',
                                  element_ids: getVisibility({ type: selected_tree_element.type, id: selected_tree_element.id, element_ids: selected_tree_element.type === 'element_wrapper' ? selected_tree_element.element_ids : [] }).element_ids
                                }), show_elements_by_takt = false
                                ">
                              visibility
                            </v-icon>
                          </v-btn>
                        </div>
                        -->
  
                        <template v-if="selected_tree_element_ifc.type !== 'elements'">
  
                          <div class="d-flex  ">
                            <div class="p-2">
                              <h3>
                                <v-icon>{{ getElementsIcon(selected_tree_element_ifc.type) }}</v-icon>
                                Type: <span class="font-weight-light">{{ selected_tree_element_ifc.type }}</span>
                              </h3>
                            </div>
                            <div class="ml-auto p-2">
                              <v-btn icon class="grey darken-5 ">
                                <v-icon
                                  :color="getVisibility({ type: selected_tree_element_ifc.type, id: selected_tree_element_ifc.id, element_ids: selected_tree_element_ifc.type === 'element_wrapper' ? selected_tree_element_ifc.element_ids : [] }).color"
                                  small @click.prevent.stop="setVisibleElements({
                                      action: getVisibility({ type: selected_tree_element_ifc.type, id: selected_tree_element_ifc.id, element_ids: selected_tree_element_ifc.type === 'element_wrapper' ? selected_tree_element_ifc.element_ids : [] }).result === 'visible' ? 'remove' : 'add',
                                      element_ids: getVisibility({ type: selected_tree_element_ifc.type, id: selected_tree_element_ifc.id, element_ids: selected_tree_element_ifc.type === 'element_wrapper' ? selected_tree_element_ifc.element_ids : [] }).element_ids
                                    }), show_elements_by_takt = false
                                    ">
                                  visibility
                                </v-icon>
                              </v-btn>
                            </div>
                          </div>
  
                          <div class="detail_list_view">
                            <div>Name: </div>
                            <div class="font-weight-light"> {{ selected_tree_element_ifc.name }}</div>
                            <div>Description: </div>
                            <div class="font-weight-light">{{ selected_tree_element_ifc.description }}</div>
                          </div>
  
  
                        </template>
  
                        <template v-if="selected_tree_element_ifc.type === 'elements'">
  
                          <ProjectStructureElementValue :set_ifc_type="true" :is_edit_mode="isEditMode" @mapValue="updateUObject({
                              url: [
                                { elements: selected_tree_element_ifc.id }
                              ],
                              url_prefix: `/projects/${project_id}/projectstructure`,
                              update: {
                                ifc_type: $event.value,
                              }
                            })
                            ">
  
                            <div class="d-flex align-items-baseline"
                              style="position: -webkit-sticky; position: sticky; top: 0;">
                              <div class="p-2">
                                <h3>
                                  <v-icon>{{ getElementsIcon(selected_tree_element_ifc.type) }}</v-icon>
                                  Type: <span class="font-weight-light">{{ selected_tree_element_ifc.ifc_type }}</span>
                                </h3>
                              </div>
                              <div class="ml-auto p-2">
                                <v-btn icon class="grey darken-5 ">
                                  <v-icon
                                    :color="getVisibility({ type: selected_tree_element_ifc.type, id: selected_tree_element_ifc.id, element_ids: selected_tree_element_ifc.type === 'element_wrapper' ? selected_tree_element_ifc.element_ids : [] }).color"
                                    small @click.prevent.stop="setVisibleElements({
                                        action: getVisibility({ type: selected_tree_element_ifc.type, id: selected_tree_element_ifc.id, element_ids: selected_tree_element_ifc.type === 'element_wrapper' ? selected_tree_element_ifc.element_ids : [] }).result === 'visible' ? 'remove' : 'add',
                                        element_ids: getVisibility({ type: selected_tree_element_ifc.type, id: selected_tree_element_ifc.id, element_ids: selected_tree_element_ifc.type === 'element_wrapper' ? selected_tree_element_ifc.element_ids : [] }).element_ids
                                      }), show_elements_by_takt = false
                                      ">
                                    visibility
                                  </v-icon>
                                </v-btn>
                              </div>
                            </div>
                          </ProjectStructureElementValue>
  
                          <div class="mt-4 mb-1">
                            <ul class="list_detail">
                              <ProjectStructureElementValue v-for=" prop  in  ['name', 'global_id', 'description'] "
                                :key="prop" :is_edit_mode="isEditMode" @changeValue="updateUObject({
                                    url: [
                                      { elements: selected_tree_element_ifc.id }
                                    ],
                                    url_prefix: `/projects/${project_id}/projectstructure`,
                                    update: {
                                      [prop]: $event,
                                    }
                                  })
                                  ">
                                <li>
                                  {{ prop }}:
                                </li>
                                <li class="font-weight-light pl-4 text-white-50">
                                  {{ selected_tree_element_ifc[prop] }}
                                </li>
                              </ProjectStructureElementValue>
                            </ul>
                          </div>
  
                          <div class="mt-4 mb-1">
                            <h3>Geometry</h3>
                            <div id="list_geometry" class="px-5">
                              <ProjectStructureElementValue
                                v-for=" (value, index)  in  $store.state.Ultra.ifc_geometry_values " :key="value.prop"
                                input_type="number" :is_edit_mode="isEditMode" @changeValue="updateUObject({
                                    url: [
                                      { elements: selected_tree_element_ifc.id }
                                    ],
                                    url_prefix: `/projects/${project_id}/projectstructure`,
                                    update: {
                                      [value.prop]: $event,
                                      [`${value.prop}_source`]: 'Set by User',
                                    }
                                  })
                                  ">
  
  
                                <div v-if="(index % 4 == 0 || (index - 1) % 4 == 0) && index > 1" 
                                  class="grid_space"></div>
  
                                <div class="detail_list_view">
                                  <div>
                                    {{ value.text }}:
                                  </div>
                                  <div class="text-muted text-white-50 text-right font-weight-light">
                                    {{ selected_tree_element_ifc[value.prop].toFixed(2) }}
                                    ({{ selected_tree_element_ifc[`${value.prop} _source`] }})
                                  </div>
                                </div>
                              </ProjectStructureElementValue>
                            </div>
                            <!-- <div>Height: {{selected_tree_element.height.toFixed(2)}} ({{selected_tree_element.height_source}})</div>
                  <div>Width: {{selected_tree_element.width.toFixed(2)}} ({{selected_tree_element.width_source}})</div>
                  <div>Length: {{selected_tree_element.length.toFixed(2)}} ({{selected_tree_element.length_source}})</div>
                  <div>Volume: {{selected_tree_element.volume.toFixed(2)}} ({{selected_tree_element.volume_source}})</div>
                  <div>Floor Area: {{selected_tree_element.floor_area.toFixed(2)}} ({{selected_tree_element.floor_area_source}})</div>
                  <div>Side Area: {{selected_tree_element.side_area.toFixed(2)}} ({{selected_tree_element.side_area_source}})</div>
                  <div>Perimeter: {{selected_tree_element.perimeter.toFixed(2)}} ({{selected_tree_element.perimeter_source}})</div>
                  <div>Lateral Surface: {{selected_tree_element.lateral_surface.toFixed(2)}} ({{selected_tree_element.lateral_surface_source}})</div>
                  <div>Weight: {{selected_tree_element.weight.toFixed(2)}} ({{selected_tree_element.weight_source}})</div> -->
                          </div>
                        </template>
  
  
                        <template v-if="selected_tree_element_ifc.type !== 'element_wrapper'">
  
                          <div class="mt-4 mb-1">
                            <h3>IFC</h3>
                            <div class="pl-1"
                              v-for=" prop_set  in  getUObjects({ type: 'propertysets', ids: selected_tree_element_ifc.propertysets }) "
                              :key="prop_set.id">
                              <!-- @click="togglePropSet({type: selected_tree_element.type, id: selected_tree_element.id, index: index})" -->
                              <div style="display: flex; cursor: pointer" @click="updateUDObject({
                                  url: [
                                    { propertysets: prop_set.id }
                                  ],
                                  update: {
                                    closed: !prop_set.closed
                                  }
                                })
                                ">
                                <v-icon>{{ prop_set.closed ? 'keyboard_arrow_right' : 'keyboard_arrow_down' }}</v-icon>
                                <div>{{ prop_set.name }}</div>
                              </div>
  
  
  
                              <div class=" pl-5" v-if="!prop_set.closed">
                                <div class="list_detail">
                                  <ProjectStructureElementValue
                                    v-for=" prop  in  getUObjects({ type: 'properties', ids: prop_set.properties }) "
                                    :key="prop.id" :map_value="true" :value_is_number="!isNaN(parseFloat(prop.value))"
                                    :is_edit_mode="isEditMode" @mapValue="updateUObject({
                                        url: [
                                          { elements: selected_tree_element_ifc.id }
                                        ],
                                        url_prefix: `/projects/${project_id}/projectstructure`,
                                        update: ['name', 'description'].includes($event.value) ?
                                          {
                                            [$event.value]: prop.value,
                                          }
                                          :
                                          {
                                            [$event.value]: !isNaN(parseFloat(prop.value)) ? parseFloat(prop.value) : prop.value,
                                            [`${$event.value}_source`]: `${prop_set.name} ${prop.name}`,
                                          }
                                      })
                                      ">
  
  
                                    <div class="detail_list_view">
                                      <div>
                                        {{ prop.name }}:
                                      </div>
                                      <div class="text-white-50 font-weight-light">
                                        {{ prop.value }}
                                      </div>
                                    </div>
                                  </ProjectStructureElementValue>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
  
                        <div class="my-3">
                          <hr>
                          <p class="py-3 pl-3 ">
                            Do you want to connect this selected IFC-Element with the Selected WORK.Step on the Right Detail
                            Bar?
                          </p>
                          <div class="ifc-detail-Button d-flex flex-row justify-content-between align-items-between w-100">
                            <v-btn class="d-flex struct-tree-filter-btn px-1" id="hp-element-background">
                              <p> View in 3D </p>
                            </v-btn>
                            <v-btn class="d-flex struct-tree-filter-btn px-1" id="hp-element-background">
                              <p> Apply to Area </p>
                            </v-btn>
                            <v-btn class="d-flex struct-tree-filter-btn px-1" id="hp-element-background">
                              <p> Apply to Step</p>
                            </v-btn>
                          </div>
                        </div>
  
                      </div>
                    </transition>
                  </div>
                </div>
  
                <!-- Hp !!! IFC Detail Fenster End-->
              </div>
  
              <div class="d-flex struct-slider-x align-items-end justify-content-end">
                <ActivatorSlider style="position: relative; right: 4px; top: 50%;" class="self-centered cursor-col-resize"
                  css_variable="--project_structure_spatial_structure_details_width_l" max_value="500" min_value="285"
                  direction="x" />
              </div>
  
            </div>
            <!-- Hp !!! Left IFC End-->
  
  
  
            <!-- Struct mittlerer main content Bereich, 3d view -->
            <div class="d-flex struct-content-center flex-column px-1" style="width: calc( 100% - (var(--project_structure_spatial_structure_details_width_l) * 1px) - (var(--project_structure_spatial_structure_details_width_r) * 1px));
               overflow: auto;
              ">
  
              <!-- Center View Area (Side buttons) -->
              <div class="struct-btn-side d-flex justify-content-center align-items-center"
                style="height: calc(100% - ( var(--project_structure_spatial_structure_details_height_c) * 1px ));">
                <div class="f-flex flex-column justify-content-center align-items-center">
  
                  <div v-for="(side_button, index) in side_buttons" :key="index">
                    <v-tooltip bottom style="z-index: 20;" id="hp-element-background" color="rgba(30, 28, 45, 0.7)">
  
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn v-on="{ ...tooltip }" height="32" width="32" min-width="32" class="hp-side-button"
                          id="hp-element-background">
                          <TIcon :name="side_button.icon" />
                        </v-btn>
                      </template>
  
                      <div class="d-flex flex-row" style="width: 200px;">
                        <TIcon :name="side_button.icon" style="width: 50px;" />
                        <div class="d-flex flex-column ">
                          {{ side_button.title }}
                          <span class="font-weight-light" style="font-size: 12px;">{{ side_button.text }}</span>
                          <span>{{ side_button.shortcut }}</span>
                        </div>
                      </div>
  
                    </v-tooltip>
                  </div>
  
                </div>
              </div>
              <!-- Center View Area (Side buttons) End -->
  
              <template v-if="selected_tree_element_ifc.type === 'elements'">
                <v-card id="hp-element-background" style="max-width: 250px;">
  
  
                  <v-card-title class="p-0 ">
                    <v-icon>{{ getElementsIcon(selected_tree_element_ifc.type) }}</v-icon>
                    Type: <span class="font-weight-light">{{ selected_tree_element_ifc.ifc_type }}</span>
                    <v-spacer></v-spacer>
                    <v-btn density="comfortable" icon color="white" @click="show_ifc_link = !show_ifc_link">
                      <TIcon name="close" />
                    </v-btn>
                  </v-card-title>
  
  
                  <v-expand-transition>
                    <div v-show="show_ifc_link"
                      style="max-height: 300px; overflow: auto; overflow-wrap: break-word; width: 100%;">
                      <v-divider></v-divider>
                      <v-card-subtitle>Verknüpfte Steps</v-card-subtitle>
                      <!-- <v-card-text v-for=" (tworkstep, index)  in  $store.state.Ultra.tworksteps.elements " :key="index"> -->
                      <v-card-text v-for=" (tworkstep, index)  in  getUObjects({ type: 'tworksteps' }) " :key="index">
  
                        <div v-if="tworkstep.elements.includes(selected_tree_element_ifc.id)">
                          {{ index }}. Workstep Text:
                          <div class="text-muted font-weight-light pl-2">
                            {{ tworkstep.text }}
                          </div>
  
                          <div class="detail_list_view ">
                            <div>
                              Workstep Id:
                            </div>
                            <div class="text-muted text-right font-weight-light">
                              {{ tworkstep.id }}
                            </div>
  
                            <div>
                              Verknüpfte Elemente:
                            </div>
                            <div class="text-muted text-right font-weight-light">
                              {{ tworkstep.elements.length }}
                            </div>
                          </div>
                        </div>
                        <div v-else></div>
                        <!--
                                {{ tworkstep }}
                              {{ getElementsStepCount(selected_tree_element_ifc.id, tworkstep.parent) }}                        
                            <div class="ml-4">name = "{{ $store.state.Ultra.tworksteps.text }}"</div>
                            -->
                      </v-card-text>
  
                    </div>
                  </v-expand-transition>
                </v-card>
  
              </template>
  
  
  
              <!-- Center Selection Collection -->
             
  
  
                <v-card class="center_collection  hp-color-drk-b06 d-flex flex-column hp-selection d-flex justify-content-end align-items-end "
                style="height: calc(var(--project_structure_spatial_structure_details_height_c) * 1px);  overflow: hidden;">
                  <!-- Activator -->
                  <div class="d-flex struct-slider">
                    <ActivatorSlider style="position: relative; top: 4px; left: 50%;"
                      class="self-centered cursor-row-resize"
                      css_variable="--project_structure_spatial_structure_details_height_c" direction="y" />
                  </div>
  
                  <v-card-title>
                    <span class="text-h5">Selection Collection</span>
                    <v-spacer></v-spacer>
                    <v-btn density="comfortable" icon color="white" @click="show_ifc_collection = !show_ifc_collection">
                      <TIcon name="close" />
                    </v-btn>
                  </v-card-title>
  
                
                    
                      <v-container class="global_filter_content flex-fill">
                        <v-row class="global_filter_content m-0 ">
  
  
                          <div class="global_filter_packages d-flex flex-fill" id="hp-element-background">
                            hi1
                          </div>
  
                          <div class="global_filter_packages d-flex flex-fill" id="hp-element-background">
                            <!-- hp !!! framework für drag n drop, Hier ist Zug, alles... Selbst überlegen wie nötig-->
                            <draggable :id="`projects#${project_id}`"
                              :group="{ name: 'trains', pull: false, put: function (to, from, dragEl) { return ['trains'].includes(dragEl.id.split('#')[0]) } }"
                              animation="300" forceFallback="true" fallbackOnBody="true"
                              :disabled="!isEditMode || select_spatial_el_ta_id !== -1" :value="project.trains"
                              style="position: relative; padding-bottom: 30px" filter=".ignore" @start="dragging = true"
                              @end="dragging = false" @update="updateUObjectPosition({
                                  url: [
                                    { projects: project_id },
                                    { trains: project.trains[$event.oldIndex] },
                                  ],
                                  update: {
                                    position: $event.newIndex - $event.oldIndex
                                  }
                                })
                                " @add="$router.push({
        name: 'ProjectStructureAddTrain',
        params: {
          project_id: project_id,
          train_index: $event.newIndex,
          train_id: project.trains[$event.newIndex],
          direction: 0,
        }
      })
      ">
                              <ProjectStructureTrain
                                v-for=" train  in  getUObjects({ type: 'trains', ids: project.trains }) " :key="train.id"
                                :train="train" :hover_el_ids="hover_el_ids"
                                :hover="hover_train_id === train.id || train.taktareas.includes(hover_ta_id)"
                                :isEditMode="isEditMode && select_spatial_el_ta_id === -1" @closeTrain="updateUDObject({
                                    url: [
                                      { projects: project_id },
                                      { trains: train.id }
                                    ],
                                    update: {
                                      closed: !train.closed
                                    }
                                  })
                                  " @changeValue="updateUObject({
        url: [
          { projects: project_id },
          { trains: train.id },
        ],
        update: {
          [$event.key]: $event.value
        }
      })
      " @headerClick="selected_tree_element_process = train, select_spatial_el_train_id = train.id"
                                @enterTrain="dragging ? '' : trainMouseEnter($event)"
                                @leaveTrain="dragging ? '' : trainMouseLeave()">
                                <template #actions>
                                  <v-btn v-if="!train.closed" small style="height: 20px" @click="toggleAllTaktareas(train)">
                                    <div>{{ getUObject({ type: 'taktareas', id: train.taktareas[0] }).closed ? 'open' :
                                      'close'
                                    }}
                                      all</div>
                                  </v-btn>
                                  <StandardDeleteButton class="ml-2" v-if="isEditMode && select_spatial_el_ta_id === -1"
                                    :zoom="0.8" @clickDelete="deleteUObject({
                                          url: [
                                            { projects: project_id },
                                            { trains: train.id },
                                          ],
                                        })
                                        " />
                                </template>
  
                                <template #body>
                                  <!-- style="height: calc(100% - 30px); display: flex; flex-direction: column" -->
                                  <draggable :id="`trains#${train.id}`"
                                    :group="{ name: 'taktareas', pull: false, put: function (to, from, dragEl) { return ['taktareas'].includes(dragEl.id.split('#')[0]) } }"
                                    animation="300" forceFallback="true" fallbackOnBody="true"
                                    :disabled="!isEditMode || select_spatial_el_ta_id !== -1" :value="train.taktareas"
                                    style="position: relative; padding-bottom: 30px" @start="dragging = true"
                                    @end="dragging = false" @update="updateUObjectPosition({
                                          url: [
                                            { projects: project_id },
                                            { trains: train.id },
                                            { taktareas: train.taktareas[$event.oldIndex] },
                                          ],
                                          update: {
                                            position: $event.newIndex - $event.oldIndex
                                          }
                                        })
                                        " @add="createUObject({
            url: [
              { projects: project_id },
              { trains: train.id },
              { taktareas: 'copytaktareabulk' },
              { showWithEntitiesNormalized: '' }
            ],
            u_object: {
              taktarea_copy: $event.newIndex === 0 ? train.taktareas[0] : train.taktareas[$event.newIndex - 1],
              taktareas: [{
                taktarea_start: getUObject({ type: 'taktareas', id: $event.newIndex === 0 ? train.taktareas[0] : train.taktareas[$event.newIndex - 1] }).taktarea_start + parseInt(1),
                position: $event.newIndex + parseInt(1)
              }]
            }
          })
          ">
                                    <ProjectStructureTaktarea
                                      v-for=" taktarea  in  getUObjects({ type: 'taktareas', ids: train.taktareas }) "
                                      :key="`taktarea${taktarea.id}`"
                                      :isEditMode="isEditMode && select_spatial_el_ta_id === -1"
                                      :hover="hover_ta_id === taktarea.id" :hover_el_ids="hover_el_ids" :taktarea="taktarea"
                                      :show_steps="step_matrix_ta_id === taktarea.id ? true : false" @closeTaktarea="taktarea.closed ?
                                            (
                                              updateUDObject({
                                                url: [
                                                  { projects: project_id },
                                                  { trains: train.id },
                                                  { taktareas: taktarea.id },
                                                ],
                                                update: {
                                                  closed: !taktarea.closed
                                                }
                                              }),
                                              requestUObject({
                                                url: [
                                                  { projects: project_id },
                                                  { trains: train.id },
                                                  { taktareas: taktarea.id },
                                                  { 'showWithEntitiesNormalized': '' }
                                                ]
                                              })
                                            )
                                            :
                                            updateUDObject({
                                              url: [
                                                { projects: project_id },
                                                { trains: train.id },
                                                { taktareas: taktarea.id },
                                              ],
                                              update: {
                                                closed: !taktarea.closed
                                              }
                                            })
                                          " @changeValue="updateUObject({
            url: [
              { projects: project_id },
              { trains: train.id },
              { taktareas: taktarea.id },
            ],
            update: {
              [$event.key]: $event.value
            }
          })
          " @mouseenter.native="dragging ? '' : taMouseEnter(taktarea)" @mouseleave.native="dragging ? '' : taMouseLeave()"
                                      @headerClick="selected_tree_element_process = taktarea, select_spatial_el_train_id = train.id">
                                      <template #activator>
                                        <ActivatorSlider v-if="step_matrix_ta_id === taktarea.id"
                                          style="position: absolute; top: 4px; left: 50%;"
                                          class="self-centered cursor-row-resize"
                                          css_variable_negative="--project_structure_taktarea_steps_height" direction="y" />
                                      </template>
                                      <template #waggons>
                                        <Waggon class="cursor-pointer"
                                          v-for=" waggon  in  getUObjects({ type: 'twaggons', ids: taktarea.twaggons }) "
                                          :key="`waggon${waggon.id}`" :workpackage_count="waggon.tworkpackages.length"
                                          :zoom="0.5">
                                          <template #content>
                                            <WorkPackage
                                              v-for=" workpackage  in  getUObjects({ type: 'tworkpackages', ids: waggon.tworkpackages }) "
                                              :key="`workpackage${workpackage.id}`"
                                              :workpackage_count="waggon.tworkpackages.length" :workpackage="workpackage"
                                              :zoom="0.5"
                                              @click.native.prevent.stop="!taktarea.closed ? (workpackage.id === step_matrix_wp_id ? (step_matrix_wp_id = false, step_matrix_ta_id = false) : (step_matrix_wp_id = workpackage.id, step_matrix_ta_id = taktarea.id)) : ''" />
                                          </template>
                                          <template #waggon-steps
                                            v-if="!taktarea.closed && step_matrix_wp_id && waggon.tworkpackages.includes(step_matrix_wp_id) && getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).tworksteps.length !== 0">
                                            <StepMatrixHeader
                                              v-for=" step  in  getUObjects({ type: 'tworksteps', ids: getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).tworksteps }) "
                                              :key="step.id">
                                              {{ step.text }}
                                            </StepMatrixHeader>
                                          </template>
                                        </Waggon>
                                      </template>
                                      <template #delete>
                                        <StandardDeleteButton class="ml-2"
                                          v-if="isEditMode && select_spatial_el_ta_id === -1" :zoom="0.8" @clickDelete="hover_ta_id = -1,
                                            deleteUObject({
                                              url: [
                                                { projects: project_id },
                                                { trains: train.id },
                                                { taktareas: taktarea.id },
                                              ],
                                            })
                                            " />
                                      </template>
                                      <template #body_name>
                                        <ProjectStructureTaktareaWrapper
                                          v-for=" wrapper  in  getChildElements({ parent_type: 'taktareas', parent_id: taktarea.id }) "
                                          :key="`body_name${wrapper.id}`" :wrapper_name="wrapper.ifc_type"
                                          :wrapper_open="taktarea.element_wrappers_open.includes(wrapper.id)"
                                          @closeTaktareaWrapper="toggleElementWrappersOpen({ parent: taktarea, id: wrapper.id })">
                                          <template #content>
                                            <ProjectStructureTaktareaElement v-for=" element  in  wrapper.elements "
                                              :key="`element${element.id}`" :name="element.name" @click.native="requestUObject({
                                                  url: [
                                                    { elements: element.id },
                                                    { showWithEntitiesNormalized: '' }
                                                  ],
                                                  url_prefix: `/projects/${project_id}/projectstructure`,
                                                  no_cache: true
                                                }).then(() => {
                                                  selected_tree_element_process = getUObject({ type: 'elements', id: element.id });
                                                })
                                                " />
                                          </template>
                                        </ProjectStructureTaktareaWrapper>
                                        <!-- <template v-if="hasPermission('Upload IFC')">
                    <ProjectStructureShape
                      v-for="shape in getUObjects({type: 'taktareashapes', ids: taktarea.taktareashapes})"
                      :key="`shape${shape.id}`"
                      :name="shape.name"
                      :is_edit_mode="isEditMode"
                      @click.native="selected_tree_element = shape, selected_shape_train_id = train.id, selected_shape_taktarea_id = taktarea.id"
                      @clickDelete="deleteUObject({
                          url: [
                            {projects: project_id},
                            {trains: train.id},
                            {taktareas: taktarea.id},
                            {taktareashapes: shape.id},
                          ]
                        })"
                      />
                    </template> -->
                                        <template v-if="isEditMode">
                                          <v-btn small
                                            :class="select_spatial_el_ta_id === taktarea.id ? 'green lighten-1' : ''"
                                            @click="select_spatial_el_ta_id === taktarea.id ?
                                                (select_spatial_el_ta_id = -1, select_spatial_el_train_id = -1) : (select_spatial_el_ta_id = taktarea.id, select_spatial_el_train_id = train.id)
                                              " style="height: 20px">
  
                                            <div v-if="select_spatial_el_ta_id === taktarea.id"><v-icon
                                                small>done</v-icon>{{
                                                  $t('Buttons.Done')
                                                }}</div>
                                            <div v-else><v-icon small>add</v-icon>{{ $t('Buttons.Select') }}</div>
                                          </v-btn>
                                          <!-- <v-btn
                        v-if="hasPermission('Upload IFC')"
                        small
                        style="height: 20px"
                        @click="createUObject({
                            url: [
                              {projects: project_id},
                              {trains: train.id},
                              {taktareas: taktarea.id},
                              {taktareashapes: ''},
                              {showWithEntitiesNormalized: ''}
                            ],
                            u_object: {
                              name: 'Shape',
                              description: '',
                              taktarea_id: taktarea.id,
                              path: [],
                              lower_level: parseFloat(-1.5),
                              height: parseFloat(20.50)
                            }
                          }).then(id => {
                              selected_tree_element = $store.state.Ultra.taktareashapes[id];
                          })
                          "
                        >
                        + Shape
                      </v-btn> -->
                                        </template>
                                      </template>
                                      <template #step_matrix>
                                        <ProjectStructureTaktareaWrapper
                                          v-for=" wrapper  in  getChildElements({ parent_type: 'taktareas', parent_id: taktarea.id }) "
                                          :key="`step_matrix${wrapper.id}`"
                                          :wrapper_open="taktarea.element_wrappers_open.includes(wrapper.id)">
                                          <template #header>
                                            <TFlex style="height: 24px; align-items: center">
                                              <Waggon class="cursor-pointer"
                                                v-for=" waggon  in  getUObjects({ type: 'twaggons', ids: taktarea.twaggons }) "
                                                :key="`waggon${waggon.id}`" :workpackage_count="waggon.tworkpackages.length"
                                                :zoom="0.5" color="red">
                                                <template #waggon-steps
                                                  v-if="!taktarea.closed && step_matrix_wp_id && waggon.tworkpackages.includes(step_matrix_wp_id) && getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).tworksteps.length !== 0">
                                                  <v-hover
                                                    v-for=" step  in  getUObjects({ type: 'tworksteps', ids: getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).tworksteps }) "
                                                    :key="`stepmatrixbody${step.id}`">
                                                    <template #default="{ hover }">
                                                      <StepMatrixBody :class="isEditMode ? 'cursor-pointer' : ''"
                                                        :color="getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).color"
                                                        :value="wrapper.element_ids.some(id => step.elements.includes(id)) || hover"
                                                        @click.native="isEditMode ?
                                                            (
                                                              requestSnackbarUpdateRelations({
                                                                project_id: project_id,
                                                                tworkstep: step.id,
                                                                action: wrapper.element_ids.some(id => step.elements.includes(id)) ? 'remove' : 'add',
                                                                conditions: [
                                                                  { ifc_type: { value: wrapper.ifc_type, operator: 'equals' } }
                                                                ]
                                                              }).then(() => {
                                                                updateUObjectRelations({
                                                                  url: [
                                                                    { projects: project_id },
                                                                    { trains: train.id },
                                                                    { taktareas: taktarea.id },
                                                                    { twaggons: waggon.id },
                                                                    { tworkpackages: step_matrix_wp_id },
                                                                    { tworksteps: step.id }
                                                                  ],
                                                                  /* url_prefix: `/projects/${project_id}/projectstructure`, */
                                                                  target_type: 'elements',
                                                                  target_ids: wrapper.element_ids,
                                                                  action: wrapper.element_ids.some(id => step.elements.includes(id)) ? 'remove' : 'add',
                                                                  bidirectional: true
                                                                })
                                                              })
                                                            ) : ''
                                                          " />
                                                    </template>
                                                  </v-hover>
                                                </template>
                                                <template #content>
                                                  <v-hover
                                                    v-for=" workpackage  in  getUObjects({ type: 'tworkpackages', ids: waggon.tworkpackages }) "
                                                    :key="`workpackage${workpackage.id}`">
                                                    <!-- :token="getElementsStepCount(element.id, workpackage.tworksteps)" -->
                                                    <template #default="{ hover }">
                                                      <WorkPackage :workpackage_count="waggon.tworkpackages.length"
                                                        :color="hover || wrapper.element_ids.some(id => getElementsStepCount(id, workpackage.tworksteps) !== 0) ? workpackage.color : ''"
                                                        :zoom="0.5"
                                                        @click.native="!taktarea.closed ? (workpackage.id === step_matrix_wp_id ? (step_matrix_wp_id = false, step_matrix_ta_id = false) : (step_matrix_wp_id = workpackage.id, step_matrix_ta_id = taktarea.id)) : ''" />
                                                    </template>
                                                  </v-hover>
                                                </template>
                                              </Waggon>
                                            </TFlex>
                                          </template>
                                          <template #content>
                                            <TFlex v-for=" element  in  wrapper.elements "
                                              :key="`step_matrix_content_element${element.id}`"
                                              style="height: 24px; align-items: center">
                                              <Waggon class="cursor-pointer"
                                                v-for=" waggon  in  getUObjects({ type: 'twaggons', ids: taktarea.twaggons }) "
                                                :key="`waggon${waggon.id}`" :workpackage_count="waggon.tworkpackages.length"
                                                :zoom="0.5" color="red">
                                                <template #waggon-steps
                                                  v-if="!taktarea.closed && step_matrix_wp_id && waggon.tworkpackages.includes(step_matrix_wp_id) && getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).tworksteps.length !== 0">
                                                  <v-hover
                                                    v-for=" step  in  getUObjects({ type: 'tworksteps', ids: getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).tworksteps }) "
                                                    :key="`stepmatrixbody${step.id}`">
                                                    <template #default="{ hover }">
                                                      <StepMatrixBody :class="isEditMode ? 'cursor-pointer' : ''"
                                                        :color="getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).color"
                                                        :value="step.elements.includes(element.id) || hover" @click.native="isEditMode ?
                                                            (
                                                              requestUObject({
                                                                url: [
                                                                  { elements: element.id },
                                                                  { showWithEntitiesNormalized: '' }
                                                                ],
                                                                url_prefix: `/projects/${project_id}/projectstructure`,
                                                                no_cache: true
                                                              }).then(() => {
                                                                requestSnackbarUpdateRelations({
                                                                  project_id: project_id,
                                                                  tworkstep: step.id,
                                                                  action: step.elements.includes(element.id) ? 'remove' : 'add',
                                                                  conditions: [
                                                                    {
                                                                      ifc_type: { value: element.ifc_type, operator: 'equals' },
                                                                      volume: { value: $store.state.Ultra.elements[element.id].volume, operator: 'equals' }
                                                                    }
                                                                  ]
                                                                }).then(() => {
                                                                  updateUObjectRelations({
                                                                    url: [
                                                                      { projects: project_id },
                                                                      { trains: train.id },
                                                                      { taktareas: taktarea.id },
                                                                      { twaggons: waggon.id },
                                                                      { tworkpackages: step_matrix_wp_id },
                                                                      { tworksteps: step.id }
                                                                    ],
                                                                    /* url_prefix: `/projects/${project_id}/projectstructure`, */
                                                                    target_type: 'elements',
                                                                    target_ids: [element.id],
                                                                    action: step.elements.includes(element.id) ? 'remove' : 'add',
                                                                    bidirectional: true
                                                                  })
                                                                })
                                                              })
                                                            ) : ''
                                                          " />
                                                    </template>
                                                  </v-hover>
                                                </template>
                                                <template #content>
                                                  <v-hover
                                                    v-for=" workpackage  in  getUObjects({ type: 'tworkpackages', ids: waggon.tworkpackages }) "
                                                    :key="`workpackage${workpackage.id}`">
                                                    <template #default="{ hover }">
                                                      <WorkPackage :workpackage_count="waggon.tworkpackages.length"
                                                        :token="getElementsStepCount(element.id, workpackage.tworksteps)"
                                                        :color="hover || getElementsStepCount(element.id, workpackage.tworksteps) !== 0 ? workpackage.color : ''"
                                                        :zoom="0.5"
                                                        @click.native="!taktarea.closed ? (workpackage.id === step_matrix_wp_id ? (step_matrix_wp_id = false, step_matrix_ta_id = false) : (step_matrix_wp_id = workpackage.id, step_matrix_ta_id = taktarea.id)) : ''" />
                                                    </template>
                                                  </v-hover>
                                                </template>
                                              </Waggon>
                                            </TFlex>
                                          </template>
                                        </ProjectStructureTaktareaWrapper>
                                      </template>
                                    </ProjectStructureTaktarea>
                                  </draggable>
                                  <TFlex v-if="isEditMode" class="ignore"
                                    style="position: absolute; bottom: 0px; font-style: italic; color: rgba(0,0,0,0.4); margin-left: 24px">
                                    <div style="overflow: hidden; white-space: nowrap">Add:</div>
                                    <v-chip style="cursor: pointer" color="rgba(0,0,0, 0.2)" class="ml-2" small @click="createUObject({
                                        url: [
                                          { projects: project_id },
                                          { trains: train.id },
                                          { taktareas: 'copytaktareabulk' },
                                          { showWithEntitiesNormalized: '' }
                                        ],
                                        u_object: {
                                          taktarea_copy: train.taktareas[train.taktareas.length - 1],
                                          taktareas: [{
                                            taktarea_start: getUObject({ type: 'taktareas', id: train.taktareas[train.taktareas.length - 1] }).taktarea_start + parseInt(1),
                                            position: train.taktareas.length - 1 + parseInt(1)
                                          }]
                                        }
                                      })
                                      ">
                                      <div style="color: rgba(255,255,255,0.7)">{{
                                        $t('Project.Structure.ProcessStructure.Taktarea')
                                      }}</div>
                                    </v-chip>
                                  </TFlex>
                                </template>
                              </ProjectStructureTrain>
  
                              <!-- hp !!! Wenn ich im Edit mode bin, kann ich Zug oder TAreahinzufügen -->
                              <TFlex v-if="isEditMode" class="ignore"
                                style="position: absolute; bottom: 0px; font-style: italic; color: rgba(0,0,0,0.4);">
                                <div style="overflow: hidden; white-space: nowrap">{{ $t('Project.Structure.DropOrSelect')
                                }}:
                                </div>
                                <v-chip style="cursor: pointer" color="rgba(0,0,0, 0.2)" class="ml-2" small @click="$router.push({
                                    name: 'ProjectStructureAddTrain',
                                    params: {
                                      project_id: project_id,
                                      train_index: 0,
                                      train_id: project.trains[0],
                                      direction: 0,
                                    }
                                  })
                                  ">
                                  <div style="color: rgba(255,255,255,0.7)">{{
                                    $t('Project.Structure.ProcessStructure.Train') }}
                                  </div>
                                </v-chip>
                              </TFlex>
                            </draggable>
  
                          </div>
                        </v-row>
  
                      </v-container>
  
  
  
                      <v-card-text>
                        Do You want to connect the selected Elements to the selected WORK.Step?
                      </v-card-text>
                      <v-card-actions class="d-flex flex-end">
                        <v-spacer></v-spacer>
                        <v-btn color="blue-darken-1" variant="text" @click="global_filter_dialog = false" size="x-small">
                          Apply for Visibility
                        </v-btn>
                        <v-btn color="blue-darken-1" variant="text" @click="global_filter_dialog = false" size="x-small">
                          Apply to Selection
                        </v-btn>
                        <v-btn color="blue-darken-1" variant="text" @click="global_filter_dialog = false" size="small">
                          Link to TAKT.Area
                        </v-btn>
                        <v-btn color="blue-darken-1" variant="text" @click="global_filter_dialog = false" size="small">
                          Link to WORK.Step
                        </v-btn>
                      </v-card-actions>
  
                    
                 
                </v-card>
  
              
  
            </div>
            <!-- Struct mittlerer main content Bereich, 3d view End -->
  
  
  
            <!-- Struct rechter main content Bereich, process Tree, Details Start -->
            <div class="d-flex struct-content-right align-items-end justify-content-end"
              style="width: calc(var(--project_structure_spatial_structure_details_width_r) * 1px); overflow: auto;">
  
              <div class="d-flex struct-slider-x align-items-start justify-content-start">
                <ActivatorSlider style="position: relative; left: 4px; top: 50%;" class="self-centered cursor-col-resize"
                  css_variable_negative="--project_structure_spatial_structure_details_width_r" max_value="500"
                  min_value="285" direction="x" />
              </div>
  
  
              <div class="d-flex struct-content-right-process flex-column align-items-end justify-content-end ">
                <div
                  class="d-flex struct-tree-process struct-tree hp-color-drk-08 w-100 flex-column align-items-start justify-content-start"
                  style="height: calc( 100% - ( var(--project_structure_spatial_structure_details_height_r) * 1px )); overflow: auto;">
  
                  <div class="struct-tree-filter d-flex flex-row w-100 align-items-start justify-content-start">
                    <div>
                      <v-btn class="d-flex struct-tree-filter-btn" id="hp-element-background">
                        <TIcon name="properties" style="font-size: auto;" />
                        <TIcon name="menu-down" />
                      </v-btn>
                    </div>
                    <div>
                      <v-btn class="d-flex struct-tree-filter-btn" id="hp-element-background">
                        <TIcon name="bullet-list" style="font-size: auto;" />
                        <TIcon name="menu-down" />
                      </v-btn>
                    </div>
                    <div>
                      <div class="d-flex struct-tree-filter-search w-auto" id="hp-element-background">
                        <input type="text" placeholder="Search.." class="input_search">
                        <TIcon name="magnifying-glass" style="font-size: auto;" />
                      </div>
                    </div>
  
                    <div>
                      <v-btn class="d-flex struct-tree-filter-btn" id="hp-element-background">
                        <TIcon name="filter-inverted" style="font-size: auto;" />
                        <TIcon name="menu-down" />
                      </v-btn>
                    </div>
  
                  </div>
  
  
  
                  <div class="struct-tree-process-content d-flex hp-color-drk-08" id="hp-element-background">
                    <!-- hier manuell über for-schleifgen Process content rein -->
  
  
  
                    <!-- hp !!! framework für drag n drop, Hier ist Zug, alles... Selbst überlegen wie nötig-->
                    <draggable :id="`projects#${project_id}`"
                      :group="{ name: 'trains', pull: false, put: function (to, from, dragEl) { return ['trains'].includes(dragEl.id.split('#')[0]) } }"
                      animation="300" forceFallback="true" fallbackOnBody="true"
                      :disabled="!isEditMode || select_spatial_el_ta_id !== -1" :value="project.trains"
                      style="position: relative; padding-bottom: 30px" filter=".ignore" @start="dragging = true"
                      @end="dragging = false" @update="updateUObjectPosition({
                          url: [
                            { projects: project_id },
                            { trains: project.trains[$event.oldIndex] },
                          ],
                          update: {
                            position: $event.newIndex - $event.oldIndex
                          }
                        })
                        " @add="$router.push({
        name: 'ProjectStructureAddTrain',
        params: {
          project_id: project_id,
          train_index: $event.newIndex,
          train_id: project.trains[$event.newIndex],
          direction: 0,
        }
      })
      ">
                      <ProjectStructureTrain v-for=" train  in  getUObjects({ type: 'trains', ids: project.trains }) "
                        :key="train.id" :train="train" :hover_el_ids="hover_el_ids"
                        :hover="hover_train_id === train.id || train.taktareas.includes(hover_ta_id)"
                        :isEditMode="isEditMode && select_spatial_el_ta_id === -1" @closeTrain="updateUDObject({
                            url: [
                              { projects: project_id },
                              { trains: train.id }
                            ],
                            update: {
                              closed: !train.closed
                            }
                          })
                          " @changeValue="updateUObject({
        url: [
          { projects: project_id },
          { trains: train.id },
        ],
        update: {
          [$event.key]: $event.value
        }
      })
      " @headerClick="selected_tree_element_process = train, select_spatial_el_train_id = train.id"
                        @enterTrain="dragging ? '' : trainMouseEnter($event)"
                        @leaveTrain="dragging ? '' : trainMouseLeave()">
                        <template #actions>
                          <v-btn v-if="!train.closed" small style="height: 20px" @click="toggleAllTaktareas(train)">
                            <div>{{ getUObject({ type: 'taktareas', id: train.taktareas[0] }).closed ? 'open' : 'close' }}
                              all</div>
                          </v-btn>
                          <StandardDeleteButton class="ml-2" v-if="isEditMode && select_spatial_el_ta_id === -1" :zoom="0.8"
                            @clickDelete="deleteUObject({
                                url: [
                                  { projects: project_id },
                                  { trains: train.id },
                                ],
                              })
                              " />
                        </template>
  
                        <template #body>
                          <!-- style="height: calc(100% - 30px); display: flex; flex-direction: column" -->
                          <draggable :id="`trains#${train.id}`"
                            :group="{ name: 'taktareas', pull: false, put: function (to, from, dragEl) { return ['taktareas'].includes(dragEl.id.split('#')[0]) } }"
                            animation="300" forceFallback="true" fallbackOnBody="true"
                            :disabled="!isEditMode || select_spatial_el_ta_id !== -1" :value="train.taktareas"
                            style="position: relative; padding-bottom: 30px" @start="dragging = true"
                            @end="dragging = false" @update="updateUObjectPosition({
                                url: [
                                  { projects: project_id },
                                  { trains: train.id },
                                  { taktareas: train.taktareas[$event.oldIndex] },
                                ],
                                update: {
                                  position: $event.newIndex - $event.oldIndex
                                }
                              })
                              " @add="createUObject({
        url: [
          { projects: project_id },
          { trains: train.id },
          { taktareas: 'copytaktareabulk' },
          { showWithEntitiesNormalized: '' }
        ],
        u_object: {
          taktarea_copy: $event.newIndex === 0 ? train.taktareas[0] : train.taktareas[$event.newIndex - 1],
          taktareas: [{
            taktarea_start: getUObject({ type: 'taktareas', id: $event.newIndex === 0 ? train.taktareas[0] : train.taktareas[$event.newIndex - 1] }).taktarea_start + parseInt(1),
            position: $event.newIndex + parseInt(1)
          }]
        }
      })
      ">
                            <ProjectStructureTaktarea
                              v-for=" taktarea  in  getUObjects({ type: 'taktareas', ids: train.taktareas }) "
                              :key="`taktarea${taktarea.id}`" :isEditMode="isEditMode && select_spatial_el_ta_id === -1"
                              :hover="hover_ta_id === taktarea.id" :hover_el_ids="hover_el_ids" :taktarea="taktarea"
                              :show_steps="step_matrix_ta_id === taktarea.id ? true : false" @closeTaktarea="taktarea.closed ?
                                  (
                                    updateUDObject({
                                      url: [
                                        { projects: project_id },
                                        { trains: train.id },
                                        { taktareas: taktarea.id },
                                      ],
                                      update: {
                                        closed: !taktarea.closed
                                      }
                                    }),
                                    requestUObject({
                                      url: [
                                        { projects: project_id },
                                        { trains: train.id },
                                        { taktareas: taktarea.id },
                                        { 'showWithEntitiesNormalized': '' }
                                      ]
                                    })
                                  )
                                  :
                                  updateUDObject({
                                    url: [
                                      { projects: project_id },
                                      { trains: train.id },
                                      { taktareas: taktarea.id },
                                    ],
                                    update: {
                                      closed: !taktarea.closed
                                    }
                                  })
                                " @changeValue="updateUObject({
        url: [
          { projects: project_id },
          { trains: train.id },
          { taktareas: taktarea.id },
        ],
        update: {
          [$event.key]: $event.value
        }
      })
      " @mouseenter.native="dragging ? '' : taMouseEnter(taktarea)" @mouseleave.native="dragging ? '' : taMouseLeave()"
                              @headerClick="selected_tree_element_process = taktarea, select_spatial_el_train_id = train.id">
                              <template #activator>
                                <ActivatorSlider v-if="step_matrix_ta_id === taktarea.id"
                                  style="position: absolute; top: 4px; left: 50%;" class="self-centered cursor-row-resize"
                                  css_variable_negative="--project_structure_taktarea_steps_height" direction="y" />
                              </template>
                              <template #waggons>
                                <Waggon class="cursor-pointer"
                                  v-for=" waggon  in  getUObjects({ type: 'twaggons', ids: taktarea.twaggons }) "
                                  :key="`waggon${waggon.id}`" :workpackage_count="waggon.tworkpackages.length" :zoom="0.5">
                                  <template #content>
                                    <WorkPackage
                                      v-for=" workpackage  in  getUObjects({ type: 'tworkpackages', ids: waggon.tworkpackages }) "
                                      :key="`workpackage${workpackage.id}`" :workpackage_count="waggon.tworkpackages.length"
                                      :workpackage="workpackage" :zoom="0.5"
                                      @click.native.prevent.stop="!taktarea.closed ? (workpackage.id === step_matrix_wp_id ? (step_matrix_wp_id = false, step_matrix_ta_id = false) : (step_matrix_wp_id = workpackage.id, step_matrix_ta_id = taktarea.id)) : ''" />
                                  </template>
                                  <template #waggon-steps
                                    v-if="!taktarea.closed && step_matrix_wp_id && waggon.tworkpackages.includes(step_matrix_wp_id) && getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).tworksteps.length !== 0">
                                    <StepMatrixHeader
                                      v-for=" step  in  getUObjects({ type: 'tworksteps', ids: getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).tworksteps }) "
                                      :key="step.id">
                                      {{ step.text }}
                                    </StepMatrixHeader>
                                  </template>
                                </Waggon>
                              </template>
                              <template #delete>
                                <StandardDeleteButton class="ml-2" v-if="isEditMode && select_spatial_el_ta_id === -1"
                                  :zoom="0.8" @clickDelete="hover_ta_id = -1,
                                    deleteUObject({
                                      url: [
                                        { projects: project_id },
                                        { trains: train.id },
                                        { taktareas: taktarea.id },
                                      ],
                                    })
                                    " />
                              </template>
                              <template #body_name>
                                <ProjectStructureTaktareaWrapper
                                  v-for=" wrapper  in  getChildElements({ parent_type: 'taktareas', parent_id: taktarea.id }) "
                                  :key="`body_name${wrapper.id}`" :wrapper_name="wrapper.ifc_type"
                                  :wrapper_open="taktarea.element_wrappers_open.includes(wrapper.id)"
                                  @closeTaktareaWrapper="toggleElementWrappersOpen({ parent: taktarea, id: wrapper.id })">
                                  <template #content>
                                    <ProjectStructureTaktareaElement v-for=" element  in  wrapper.elements "
                                      :key="`element${element.id}`" :name="element.name" @click.native="requestUObject({
                                          url: [
                                            { elements: element.id },
                                            { showWithEntitiesNormalized: '' }
                                          ],
                                          url_prefix: `/projects/${project_id}/projectstructure`,
                                          no_cache: true
                                        }).then(() => {
                                          selected_tree_element_process = getUObject({ type: 'elements', id: element.id });
                                        })
                                        " />
                                  </template>
                                </ProjectStructureTaktareaWrapper>
                                <!-- <template v-if="hasPermission('Upload IFC')">
                    <ProjectStructureShape
                      v-for="shape in getUObjects({type: 'taktareashapes', ids: taktarea.taktareashapes})"
                      :key="`shape${shape.id}`"
                      :name="shape.name"
                      :is_edit_mode="isEditMode"
                      @click.native="selected_tree_element = shape, selected_shape_train_id = train.id, selected_shape_taktarea_id = taktarea.id"
                      @clickDelete="deleteUObject({
                          url: [
                            {projects: project_id},
                            {trains: train.id},
                            {taktareas: taktarea.id},
                            {taktareashapes: shape.id},
                          ]
                        })"
                      />
                    </template> -->
                                <template v-if="isEditMode">
                                  <v-btn small :class="select_spatial_el_ta_id === taktarea.id ? 'green lighten-1' : ''"
                                    @click="select_spatial_el_ta_id === taktarea.id ?
                                        (select_spatial_el_ta_id = -1, select_spatial_el_train_id = -1) : (select_spatial_el_ta_id = taktarea.id, select_spatial_el_train_id = train.id)
                                      " style="height: 20px">
  
                                    <div v-if="select_spatial_el_ta_id === taktarea.id"><v-icon small>done</v-icon>{{
                                      $t('Buttons.Done')
                                    }}</div>
                                    <div v-else><v-icon small>add</v-icon>{{ $t('Buttons.Select') }}</div>
                                  </v-btn>
                                  <!-- <v-btn
                        v-if="hasPermission('Upload IFC')"
                        small
                        style="height: 20px"
                        @click="createUObject({
                            url: [
                              {projects: project_id},
                              {trains: train.id},
                              {taktareas: taktarea.id},
                              {taktareashapes: ''},
                              {showWithEntitiesNormalized: ''}
                            ],
                            u_object: {
                              name: 'Shape',
                              description: '',
                              taktarea_id: taktarea.id,
                              path: [],
                              lower_level: parseFloat(-1.5),
                              height: parseFloat(20.50)
                            }
                          }).then(id => {
                              selected_tree_element = $store.state.Ultra.taktareashapes[id];
                          })
                          "
                        >
                        + Shape
                      </v-btn> -->
                                </template>
                              </template>
                              <template #step_matrix>
                                <ProjectStructureTaktareaWrapper
                                  v-for=" wrapper  in  getChildElements({ parent_type: 'taktareas', parent_id: taktarea.id }) "
                                  :key="`step_matrix${wrapper.id}`"
                                  :wrapper_open="taktarea.element_wrappers_open.includes(wrapper.id)">
                                  <template #header>
                                    <TFlex style="height: 24px; align-items: center">
                                      <Waggon class="cursor-pointer"
                                        v-for=" waggon  in  getUObjects({ type: 'twaggons', ids: taktarea.twaggons }) "
                                        :key="`waggon${waggon.id}`" :workpackage_count="waggon.tworkpackages.length"
                                        :zoom="0.5" color="red">
                                        <template #waggon-steps
                                          v-if="!taktarea.closed && step_matrix_wp_id && waggon.tworkpackages.includes(step_matrix_wp_id) && getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).tworksteps.length !== 0">
                                          <v-hover
                                            v-for=" step  in  getUObjects({ type: 'tworksteps', ids: getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).tworksteps }) "
                                            :key="`stepmatrixbody${step.id}`">
                                            <template #default="{ hover }">
                                              <StepMatrixBody :class="isEditMode ? 'cursor-pointer' : ''"
                                                :color="getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).color"
                                                :value="wrapper.element_ids.some(id => step.elements.includes(id)) || hover"
                                                @click.native="isEditMode ?
                                                    (
                                                      requestSnackbarUpdateRelations({
                                                        project_id: project_id,
                                                        tworkstep: step.id,
                                                        action: wrapper.element_ids.some(id => step.elements.includes(id)) ? 'remove' : 'add',
                                                        conditions: [
                                                          { ifc_type: { value: wrapper.ifc_type, operator: 'equals' } }
                                                        ]
                                                      }).then(() => {
                                                        updateUObjectRelations({
                                                          url: [
                                                            { projects: project_id },
                                                            { trains: train.id },
                                                            { taktareas: taktarea.id },
                                                            { twaggons: waggon.id },
                                                            { tworkpackages: step_matrix_wp_id },
                                                            { tworksteps: step.id }
                                                          ],
                                                          /* url_prefix: `/projects/${project_id}/projectstructure`, */
                                                          target_type: 'elements',
                                                          target_ids: wrapper.element_ids,
                                                          action: wrapper.element_ids.some(id => step.elements.includes(id)) ? 'remove' : 'add',
                                                          bidirectional: true
                                                        })
                                                      })
                                                    ) : ''
                                                  " />
                                            </template>
                                          </v-hover>
                                        </template>
                                        <template #content>
                                          <v-hover
                                            v-for=" workpackage  in  getUObjects({ type: 'tworkpackages', ids: waggon.tworkpackages }) "
                                            :key="`workpackage${workpackage.id}`">
                                            <!-- :token="getElementsStepCount(element.id, workpackage.tworksteps)" -->
                                            <template #default="{ hover }">
                                              <WorkPackage :workpackage_count="waggon.tworkpackages.length"
                                                :color="hover || wrapper.element_ids.some(id => getElementsStepCount(id, workpackage.tworksteps) !== 0) ? workpackage.color : ''"
                                                :zoom="0.5"
                                                @click.native="!taktarea.closed ? (workpackage.id === step_matrix_wp_id ? (step_matrix_wp_id = false, step_matrix_ta_id = false) : (step_matrix_wp_id = workpackage.id, step_matrix_ta_id = taktarea.id)) : ''" />
                                            </template>
                                          </v-hover>
                                        </template>
                                      </Waggon>
                                    </TFlex>
                                  </template>
                                  <template #content>
                                    <TFlex v-for=" element  in  wrapper.elements "
                                      :key="`step_matrix_content_element${element.id}`"
                                      style="height: 24px; align-items: center">
                                      <Waggon class="cursor-pointer"
                                        v-for=" waggon  in  getUObjects({ type: 'twaggons', ids: taktarea.twaggons }) "
                                        :key="`waggon${waggon.id}`" :workpackage_count="waggon.tworkpackages.length"
                                        :zoom="0.5" color="red">
                                        <template #waggon-steps
                                          v-if="!taktarea.closed && step_matrix_wp_id && waggon.tworkpackages.includes(step_matrix_wp_id) && getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).tworksteps.length !== 0">
                                          <v-hover
                                            v-for=" step  in  getUObjects({ type: 'tworksteps', ids: getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).tworksteps }) "
                                            :key="`stepmatrixbody${step.id}`">
                                            <template #default="{ hover }">
                                              <StepMatrixBody :class="isEditMode ? 'cursor-pointer' : ''"
                                                :color="getUObject({ type: 'tworkpackages', id: step_matrix_wp_id }).color"
                                                :value="step.elements.includes(element.id) || hover" @click.native="isEditMode ?
                                                    (
                                                      requestUObject({
                                                        url: [
                                                          { elements: element.id },
                                                          { showWithEntitiesNormalized: '' }
                                                        ],
                                                        url_prefix: `/projects/${project_id}/projectstructure`,
                                                        no_cache: true
                                                      }).then(() => {
                                                        requestSnackbarUpdateRelations({
                                                          project_id: project_id,
                                                          tworkstep: step.id,
                                                          action: step.elements.includes(element.id) ? 'remove' : 'add',
                                                          conditions: [
                                                            {
                                                              ifc_type: { value: element.ifc_type, operator: 'equals' },
                                                              volume: { value: $store.state.Ultra.elements[element.id].volume, operator: 'equals' }
                                                            }
                                                          ]
                                                        }).then(() => {
                                                          updateUObjectRelations({
                                                            url: [
                                                              { projects: project_id },
                                                              { trains: train.id },
                                                              { taktareas: taktarea.id },
                                                              { twaggons: waggon.id },
                                                              { tworkpackages: step_matrix_wp_id },
                                                              { tworksteps: step.id }
                                                            ],
                                                            /* url_prefix: `/projects/${project_id}/projectstructure`, */
                                                            target_type: 'elements',
                                                            target_ids: [element.id],
                                                            action: step.elements.includes(element.id) ? 'remove' : 'add',
                                                            bidirectional: true
                                                          })
                                                        })
                                                      })
                                                    ) : ''
                                                  " />
                                            </template>
                                          </v-hover>
                                        </template>
                                        <template #content>
                                          <v-hover
                                            v-for=" workpackage  in  getUObjects({ type: 'tworkpackages', ids: waggon.tworkpackages }) "
                                            :key="`workpackage${workpackage.id}`">
                                            <template #default="{ hover }">
                                              <WorkPackage :workpackage_count="waggon.tworkpackages.length"
                                                :token="getElementsStepCount(element.id, workpackage.tworksteps)"
                                                :color="hover || getElementsStepCount(element.id, workpackage.tworksteps) !== 0 ? workpackage.color : ''"
                                                :zoom="0.5"
                                                @click.native="!taktarea.closed ? (workpackage.id === step_matrix_wp_id ? (step_matrix_wp_id = false, step_matrix_ta_id = false) : (step_matrix_wp_id = workpackage.id, step_matrix_ta_id = taktarea.id)) : ''" />
                                            </template>
                                          </v-hover>
                                        </template>
                                      </Waggon>
                                    </TFlex>
                                  </template>
                                </ProjectStructureTaktareaWrapper>
                              </template>
                            </ProjectStructureTaktarea>
                          </draggable>
                          <TFlex v-if="isEditMode" class="ignore"
                            style="position: absolute; bottom: 0px; font-style: italic; color: rgba(0,0,0,0.4); margin-left: 24px">
                            <div style="overflow: hidden; white-space: nowrap">Add:</div>
                            <v-chip style="cursor: pointer" color="rgba(0,0,0, 0.2)" class="ml-2" small @click="createUObject({
                                url: [
                                  { projects: project_id },
                                  { trains: train.id },
                                  { taktareas: 'copytaktareabulk' },
                                  { showWithEntitiesNormalized: '' }
                                ],
                                u_object: {
                                  taktarea_copy: train.taktareas[train.taktareas.length - 1],
                                  taktareas: [{
                                    taktarea_start: getUObject({ type: 'taktareas', id: train.taktareas[train.taktareas.length - 1] }).taktarea_start + parseInt(1),
                                    position: train.taktareas.length - 1 + parseInt(1)
                                  }]
                                }
                              })
                              ">
                              <div style="color: rgba(255,255,255,0.7)">{{ $t('Project.Structure.ProcessStructure.Taktarea')
                              }}</div>
                            </v-chip>
                          </TFlex>
                        </template>
                      </ProjectStructureTrain>
  
                      <!-- hp !!! Wenn ich im Edit mode bin, kann ich Zug oder TAreahinzufügen -->
                      <TFlex v-if="isEditMode" class="ignore"
                        style="position: absolute; bottom: 0px; font-style: italic; color: rgba(0,0,0,0.4);">
                        <div style="overflow: hidden; white-space: nowrap">{{ $t('Project.Structure.DropOrSelect') }}:</div>
                        <v-chip style="cursor: pointer" color="rgba(0,0,0, 0.2)" class="ml-2" small @click="$router.push({
                          name: 'ProjectStructureAddTrain',
                          params: {
                            project_id: project_id,
                            train_index: 0,
                            train_id: project.trains[0],
                            direction: 0,
                          }
                        })
                          ">
                          <div style="color: rgba(255,255,255,0.7)">{{ $t('Project.Structure.ProcessStructure.Train') }}
                          </div>
                        </v-chip>
                      </TFlex>
                    </draggable>
  
  
                  </div>
                </div>
  
                <!-- Activator hier rein -->
                <div class="d-flex flex-column struct-details"
                  style="height: calc(var(--project_structure_spatial_structure_details_height_r) * 1px);  overflow: auto; ">
  
                  <div class="d-flex struct-slider">
                    <ActivatorSlider style="position: relative; top: 4px; left: 50%;"
                      class="self-centered cursor-row-resize"
                      css_variable="--project_structure_spatial_structure_details_height_r" direction="y" />
                  </div>
  
                  <div class="d-flex struct-details-process hp-color-drk-08 ">
  
  
  
                    <!-- taktarea/trains details -->
                    <div
                      v-if="snackbar.show || selected_tree_element_process.id !== -1 && ['trains', 'taktareas', 'taktareashapes'].includes(selected_tree_element_process.type)"
                      class="grey darken-3 pa-1" style=" overflow: auto;">
  
                      <template v-if="snackbar.show && snackbar.response.taktareas.length !== 0">
                        <div class="TFlex">
                          <v-btn color="green" @click="applySnackbar()">apply</v-btn>
                          <v-btn @click="updateSnackbar({
                              show: false
                            })
                            ">
                            cancel
                          </v-btn>
                        </div>
                        <div class="mb-1 mt-1">Do you want to {{ snackbar.action.toUpperCase() }} elements with
                          condition
                        </div>
                        <div class="ml-4" style="display: flex" v-for="( condition, index ) in  snackbar.conditions "
                          :key="`cond${index}`">
                          <div style="display: flex" v-for="( prop, prop_index ) in  Object.keys(condition) "
                            :key="index + prop">
                            <div>{{ prop }} = {{ condition[prop].value }}</div>
                            <div class="ml-4 mr-2" v-if="prop_index !== Object.keys(condition).length - 1">AND</div>
                          </div>
                        </div>
                        <div class="mb-1 mt-1">{{ snackbar.action === 'add' ? 'to' : 'from' }} WORK.step width condition
                        </div>
                        <div class="ml-4">name = "{{ $store.state.Ultra.tworksteps[snackbar.tworkstep_id].text }}"</div>
                        <div class="mb-1 mt-1">in the following taktareas:</div>
                        <div class="ml-4" v-for=" taktarea  in  snackbar.response.taktareas " :key="taktarea.id">
                          <div v-if="taktarea.elements && taktarea.elements.length !== 0">
                            {{ $store.state.Ultra.taktareas[taktarea.id].name }}: {{ taktarea.elements.length }}
                            elements
                          </div>
                        </div>
                      </template>
  
                      <template v-else>
                        <v-card>
                          <v-tabs bg-color="deep-purple-darken-4" center-active v-model="tab">
  
                            <v-tab value="trains" :class="selected_tree_element_process.type == 'trains' ? 'active' : ''">
                              Trains </v-tab>
                            <v-tab value="taktareas"
                              :class="selected_tree_element_process.type == 'taktareas' ? 'active' : ''"> TAKT.Areas
                            </v-tab>
                            <v-tab value="twaggons" :class="{ active: selected_tree_element_process.type === 'twaggons' }">
                              Waggons</v-tab>
                            <v-tab value="package" :class="{ active: selected_tree_element_process.type === 'pack' }">
                              Package</v-tab>
                            <v-tab value="step" :class="{ active: selected_tree_element_process.type === 'step' }">
                              Steps</v-tab>
                          </v-tabs>
  
                          <v-card-text class="struct-details-process">
                            <v-window v-model="tab">
  
                              <v-window-item value="trains"
                                :class="selected_tree_element_process.type === 'trains' ? 'active' : ''">
  
  
                                <!-- Hier interessant, hier wird inhalt von Process details bestimmt -->
                                type : {{ selected_tree_element_process.type }} <br>
                                name : {{ selected_tree_element_process.name }} <br>
                                id : {{ selected_tree_element_process.id }} <br>
                                description : {{ selected_tree_element_process.description }} <br>
                                taktareas : {{ selected_tree_element_process.taktareas }} <br>
                                {{ selected_tree_element_process }} <br>
  
                                <!-- Btn der das schließt
                        <v-btn @click="selected_tree_element_process = { type: 'elements', id: -1 }" icon>
                          <v-icon>keyboard_arrow_down</v-icon>
                        </v-btn>
                        -->
                                <v-btn v-if="selected_tree_element_process.type === 'taktareashapes'" @click="addUObjects({
                                    url: [
                                      { projects: project_id },
                                      { trains: 0 },
                                      { taktareas: selected_tree_element_process.taktarea_id },
                                      { add: '' }
                                    ],
                                    u_objects: {
                                      target_type: 'elements',
                                      target_ids: selected_elements
                                    }
                                  })
                                  ">
                                  add elements
                                </v-btn>
                              </v-window-item>
  
                              <v-window-item value="taktareas"
                                :class="selected_tree_element_process.type === 'taktareas' ? 'active' : ''">
  
  
                                <!-- Hier interessant, hier wird inhalt von Process details bestimmt -->
                                {{ selected_tree_element_process.type }} <br>
                                {{ selected_tree_element_process.name }} <br>
                                {{ selected_tree_element_process.id }} <br>
                                {{ selected_tree_element_process.description }} <br>
                                {{ selected_tree_element_process.taktareas }} <br>
                                {{ selected_tree_element_process }} <br>
  
                                <v-btn v-if="selected_tree_element_process.type === 'taktareashapes'" @click="addUObjects({
                                    url: [
                                      { projects: project_id },
                                      { trains: 0 },
                                      { taktareas: selected_tree_element_process.taktarea_id },
                                      { add: '' }
                                    ],
                                    u_objects: {
                                      target_type: 'elements',
                                      target_ids: selected_elements
                                    }
                                  })
                                  ">
                                  add elements
                                </v-btn>
                              </v-window-item>
  
                              <v-window-item value="twaggons">
  
  
                                <!-- Hier interessant, hier wird inhalt von Process details bestimmt -->
                                {{ selected_tree_element_process.type }} <br>
                                {{ selected_tree_element_process.name }} <br>
                                {{ selected_tree_element_process.id }} <br>
                                {{ selected_tree_element_process.description }} <br>
                                {{ selected_tree_element_process.taktareas }} <br>
                                {{ selected_tree_element_process }} <br>
  
  
                                <v-btn v-if="selected_tree_element_process.type === 'taktareashapes'" @click="addUObjects({
                                    url: [
                                      { projects: project_id },
                                      { trains: 0 },
                                      { taktareas: selected_tree_element_process.taktarea_id },
                                      { add: '' }
                                    ],
                                    u_objects: {
                                      target_type: 'elements',
                                      target_ids: selected_elements
                                    }
                                  })
                                  ">
                                  add elements
                                </v-btn>
                              </v-window-item>
  
                              <v-window-item value="package">
  
  
                                <!-- Hier interessant, hier wird inhalt von Process details bestimmt -->
                                {{ selected_tree_element_process.type }} <br>
                                {{ selected_tree_element_process.name }} <br>
                                {{ selected_tree_element_process.id }} <br>
                                {{ selected_tree_element_process.description }} <br>
                                {{ selected_tree_element_process.taktareas }} <br>
                                {{ selected_tree_element_process }} <br>
  
                                <v-btn v-if="selected_tree_element_process.type === 'taktareashapes'" @click="addUObjects({
                                    url: [
                                      { projects: project_id },
                                      { trains: 0 },
                                      { taktareas: selected_tree_element_process.taktarea_id },
                                      { add: '' }
                                    ],
                                    u_objects: {
                                      target_type: 'elements',
                                      target_ids: selected_elements
                                    }
                                  })
                                  ">
                                  add elements
                                </v-btn>
                              </v-window-item>
  
                              <v-window-item value="step">
  
  
                                <!-- Hier interessant, hier wird inhalt von Process details bestimmt -->
                                {{ selected_tree_element_process.type }} <br>
                                {{ selected_tree_element_process.name }} <br>
                                {{ selected_tree_element_process.id }} <br>
                                {{ selected_tree_element_process.description }} <br>
                                {{ selected_tree_element_process.taktareas }} <br>
                                {{ selected_tree_element_process }} <br>
  
  
                                <v-btn v-if="selected_tree_element_process.type === 'taktareashapes'" @click="addUObjects({
                                    url: [
                                      { projects: project_id },
                                      { trains: 0 },
                                      { taktareas: selected_tree_element_process.taktarea_id },
                                      { add: '' }
                                    ],
                                    u_objects: {
                                      target_type: 'elements',
                                      target_ids: selected_elements
                                    }
                                  })
                                  ">
                                  add elements
                                </v-btn>
                              </v-window-item>
  
  
                            </v-window>
                          </v-card-text>
                        </v-card>
                      </template>
                    </div>
                  </div>
  
                </div>
  
              </div>
  
  
  
  
            </div>
  
          </div>
        </div>
      </ProjectStructureBuildingModelNew>
    </div>
  </template>
  
  
  <script>
  import store from '@/store/index';
  import { mapGetters, mapActions } from 'vuex';
  
  import { ProjectStructureMixin } from '@/mixins/ProjectStructure.mixin.js'
  // hp !!! Hier passiert 3d Hintergrundabläufe
  // import { IfcJSMixin } from '@/mixins/IfcJS.mixin.js'
  import { ProjectStructureBuildingModelMixin } from '@/mixins/ProjectStructureBuildingModel.mixin.js'
  // import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue'
  // import ProjectStructureElementValue from '@/components/ProjectStructure/ProjectStructureElementValue.component.vue'
  // import TText from '@/components/Taktify/TText.component.vue'
  import TIcon from '@/components/Taktify/TIcon.component.vue'
  // import TTooltip from '@/components/Taktify/TTooltip.component.vue'
  // import { mergeProps } from 'vue'
  import ActivatorSlider from '@/components/ProjectTaktPlan/ActivatorSlider.component.vue';
  
  export default {
    mixins: [
      ProjectStructureMixin,
      ProjectStructureBuildingModelMixin,
      // IfcJSMixin,
    ],
    components: {
      // DropDownOutlinedFlat,
      // ProjectStructureElementValue,
      // TText,
      TIcon,
      ActivatorSlider,
      // TTooltip,
    },
    data: () => ({
      open: ['Struct_Modes'],
      loading_structure: true,
      global_filter_dialog: false,
      show_ifc_import_dialog: false,
      ifc_upload_done: false,
      selected_import_strategy: { value: 'default' },
      menu_layer_filter_ifc: false,
      menu_view_filter_ifc: false,
      isSorted_IFC: false,
      show_ifc_link: false,
      show_ifc_collection: false,
      toggle_mandatory: 0,
      struct_modes: [
        { title: 'Zuweisungs Mode', icon: 'takt-plan', text: 'Um IFC-Elemente auszuwählen und dem Prozess zuzuweisen', shortcut: 'ctrl + Tab' },
        { title: 'TAKT-Zuweisungs Mode', icon: 'takt-structure', text: 'Um Prozess-Elemente auszuwählen und dem IFC zuzuweisen', shortcut: 'ctrl + Tab' },
        { title: 'Time Mode', icon: 'stopwatch', text: 'Um Zugewisene Elemente im zeitlichen Ablauf zu visualisieren', shortcut: 'ctrl + t' },
        { title: 'Evaluation Mode', icon: 'file-check', text: 'Um Projektverläufe und Erfolge visuell darzustellen', shortcut: 'ctrl + e' },
        { title: 'Edit Mode', icon: 'pencil', text: 'Um Elemente zu bearbeiten', shortcut: 'ctrl + Tab' }
      ],
      side_buttons: [
        { title: 'hold', icon: 'glove', text: 'Zum manuellen Verschieben der 3D-Darstellung', shortcut: 'ctrl + h' },
        { title: 'zoom in', icon: 'zoom-in', text: 'Zum Heranzoomen in die 3D-Darstellung', shortcut: 'ctrl + +' },
        { title: 'zoom out', icon: 'zoom-out', text: 'Zum Herauszoomen in die 3D-Darstellung', shortcut: 'ctrl + -' },
        { title: 'reposition', icon: 'perspective-floor', text: 'Zum umschänken der Kamera indie Defaultansicht', shortcut: 'ctrl + d' },
        { title: 'time', icon: 'checked-stopwatch', text: 'Zum iterativen Darstellen des 3D-Models nach Steps ', shortcut: 'ctrl + t' },
        { title: 'comment', icon: 'checkbox-radial-editor', text: 'Zum Kommentieren des ausgewählten Elements', shortcut: 'ctrl + c' },
        { title: 'mesure', icon: 'crossed-pencil-ruler', text: 'Zum Anzeigen der zugehörigen Maße', shortcut: 'ctrl + m' },
        { title: 'object rotation', icon: 'perspective-walls', text: 'Zum schwänken der 3D-Darstellung in X-Richtung ', shortcut: 'ctrl + x' },
      ],
      local_view_filter: [
        { title: 'hide already connected', state: 'false', type: 'filter' },
        { title: 'hide not connected', state: 'false', type: 'filter' },
        { title: 'hide visible', state: 'false', type: 'filter' },
        { title: 'hide not visible', state: 'false', type: 'filter' },
      ],
      local_sort_filter: [
        { title: 'downwards', isDownwards: 'true', icon: 'arrow-down', },
        { title: 'upwards', isUpwards: 'false', icon: 'arrow-up', },
      ],
      active_struct_mode: '',
      selected_tree_element_ifc: { type: 'elements', id: -1 },
      selected_tree_element_process: { type: 'taktareas', id: -1 },
    }),
    created() {
      //deactivate building model
      // if (!this.hasPermission('Upload IFC')) {
      //   let index = this.tabs.findIndex(tab => tab.identifier === 'buildingmodel');
      //   if (index !== -1) {
      //     this.tabs.splice(index, 1);
      //   }
      // }
      this.active_struct_mode = this.struct_modes[0].title,
        store.dispatch('Ultra/requestUObject', {
          url: [
            { projects: this.project_id },
            { taktareaselements: '' }
          ],
        });
    },
    mounted() {
      // let tab = this.tabs.find(tab => tab.identifier === 'buildingmodel');
      // if (!tab || (tab && !tab.show)) {
      store.dispatch('Ultra/requestUObject', {
        url: [
          { projects: parseInt(this.project_id) },
          { projectstructure: '' }
        ],
      }).then(() => {
        this.requestProjectElements(this.project_id).then(() => {
          this.loading_structure = false;
        })
      });
      // }
    },
    computed: {
      ...mapGetters('ProjectStructure', [
        'getImportStrategies',
      ]),
      project_id() {
        return parseInt(this.$route.params.project_id);
      },
      project() {
        return store.state.Ultra.projects[this.$route.params.project_id];
      }
    },
    // beforeRouteEnter(to, from, next) {
    //   store.dispatch('Ultra/requestUObject', {
    //     url: [
    //       {projects: parseInt(to.params.project_id)},
    //       {projectstructure: ''}
    //     ],
    //   }).then(() => {
    //       next();
    //   });
    // },
    methods: {
      // mergeProps,
      btnTitle(index) {
        this.active_struct_mode = this.struct_modes[index];
      },
      ...mapActions('Ultra', [
        'requestUObject'
      ]),
      routeTo(route) {
        window.location.href = route;
      },
      openNewTab(route) {
        window.open(route);
      },
      getElementsStepCount(element_id, workpackage_steps) {
        let count = 0;
        let steps = this.getUObjects({ type: 'tworksteps', ids: workpackage_steps });
        steps.forEach(step => {
          if (step.elements.includes(element_id)) {
            count++;
          }
        })
        return count
      },
      getMissingSteps(element_steps, workpackage_steps) {
        let steps = [];
        workpackage_steps.forEach(step => {
          if (!element_steps.includes(step)) {
            steps.push(step);
          }
        });
        return steps;
      },
      requestBusiness() {
        let current_user = this.$store.getters['Auth/getUser'];
        if (current_user.business.id) {
          this.requestUObject({
            url: [
              { businesses: current_user.business.id },
              { showWithEntitiesNormalized: '' }
            ]
          }).then(() => {
            this.requestUObject({
              url: [
                { businesses: current_user.business.id },
                { bifcimportstrategies: '' },
                { showWithEntitiesNormalized: '' }
              ],
              add_u_object: true
            })
          })
        }
      },
  
      // hp !!! könnte später wichtig werden
      treeElementClicked(evt) {
        if (this.isEditMode && this.select_spatial_el_ta_id !== -1 && evt.element.type !== 'elements') {
          let element_ids;
          if (evt.element.type === 'element_wrapper') {
            element_ids = evt.element.element_ids;
          } else {
            element_ids = this.getAllChildElements({
              parent_type: evt.element.type,
              parent_id: evt.element.id,
            });
          }
          this.selectAllSpatialContainerElements(element_ids);
        } else if (evt.element.type === 'element_wrapper') {
          this.selected_tree_element_ifc = evt.element
        } else if (evt.element.type === 'elements' && this.$store.state.Ultra[evt.element.type][evt.element.id] || evt.element.type !== 'elements' && this.$store.state.Ultra[evt.element.type][evt.element.id].propertysets) {
          this.selected_tree_element_ifc = this.getUObject({ type: evt.element.type, id: evt.element.id })
        } else {
          this.requestUObject({
            url: [
              { [evt.element.type]: evt.element.id },
              { showWithEntitiesNormalized: '' }
            ],
            url_prefix: `/projects/${this.project_id}/projectstructure`,
            no_cache: true
          }).then(() => {
            this.selected_tree_element_ifc = this.getUObject({ type: evt.element.type, id: evt.element.id });
          })
  
        }
      }
    },
  }
  </script>
  
  
  
  <style lang="scss" scoped>
  // Generelle Style Settings
  .hp-color-drk-b01 {
    background-color: #B9b3ff;
  }
  
  .hp-color-drk-b02 {
    background-color: #a7a1e6;
  }
  
  .hp-color-drk-b03 {
    background-color: #948fcc;
  }
  
  .hp-color-drk-b04 {
    background-color: #827db3;
  }
  
  .hp-color-drk-b05 {
    background-color: #6f6b99;
  }
  
  .hp-color-drk-b06 {
    background-color: #5d5980;
  }
  
  .hp-color-drk-b07 {
    background-color: #4a4766;
  }
  
  .hp-color-drk-08 {
    background-color: #2e2c40;
  }
  
  // ! später nochmal anschauen
  p {
    font-size: 12px;
  }
  
  
  // Container/ Area Defining Style Settings
  
  
  .hp-canvas-bckgrnd {
    width: 100vw;
    height: 100vh;
    // background-color: rgba(255, 0, 0, 0.108);
    // background: rgba(75, 160, 255, 0.3);
    // background: radial-gradient(circle, rgba(129,127,172,1) 0%, rgba(64,64,107,1) 100%);
    // background: radial-gradient(circle,  #2c5364 0%, #203a43 70%,  #0f2027 100%);
    // background: radial-gradient(circle, #243b55 0%, #243b55 30%, #141e30 100%);
    background: radial-gradient(circle, #BEAECF 0%, #99C0C8 20%, #7A97AE 60%, #6B73A7 80%, #53528A 100%);
    background-position: center;
    background-attachment: fixed;
    position: absolute;
  
  }
  
  .hp-content-struct {
    // margin-top: 100px;
    height: 100vh;
    width: 100vw;
    max-height: 100%;
    max-width: 100%;
    overflow: auto;
  }
  
  .struct-container {
    // margin-top: 100px;
    // height: 100vh;
    // width: 100vw;
    // max-height: 100%;
    // max-width: 100%;
    height: calc(100% - 60px);
    width: 100vw;
    overflow: auto;
  }
  
  .hp-top-bar {
    width: 100%;
    max-height: 60px;
    // top: auto;
    z-index: 5;
    display: flex;
    flex-direction: row;
    justify-content: space-between
  }
  
  .hp-mode-switch,
  .hp-status,
  .hp-global-filter {
    height: auto;
    width: auto;
    margin: 10px;
  }
  
  
  
  .hp-toggle-background {
    height: auto;
    width: auto;
  
    /*
    min-width: none;
    background-color: rgba(30, 28, 45, 0.8);
    backdrop-filter: blur(24px) brightness(95%);
    -webkit-backdrop-filter: blur(24px) brightness(95%);
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    */
  }
  
  
  // lieber in id #. da damit höhere
  #hp-element-background {
    // height: auto;
    // width: auto;
    min-width: none;
    // background-color: rgba(30, 28, 45, 0.8);
    background: rgba(30, 28, 45, 0.7);
    backdrop-filter: blur(24px) brightness(95%);
    -webkit-backdrop-filter: blur(24px) brightness(95%);
    // margin: 10px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  }
  
  .hp-blur-background {
    // background: rgba(30, 28, 45, 0.2);
    background-color: rgba(30, 28, 45, 0.7);
    backdrop-filter: blur(24px) brightness(95%);
    -webkit-backdrop-filter: blur(24px) brightness(95%);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  }
  
  .struct-global-filter {
    width: 80vw;
    height: 80vh;
  }
  
  .global_filter_packages {
    width: 350px;
    // min-height: 225px;
    height: 100%;
  
  
    display: flex;
    position: relative;
    align-items: stretch;
  }
  
  .global_filter_content {
    display: flex;
    position: relative;
    align-items: stretch;
    gap: 10px;
    padding: 0 10px;
    width: 100%;
  
  
  }
  
  .hp-selection {
    //  height: 100vh;
    //  width: 100vw;
    height: 100%;
    width: 100%;
    // max-height: auto;
    // max-width: auto;
    min-height: 60px;
    // padding: 10px;
    overflow: hidden;
    display: flex;
    position: relative;
  }
  
  .center_collection {
    //  height: 100vh;
    //  width: 100vw;
    height: 100%;
    width: 100%;
    // max-height: auto;
    // max-width: auto;
    min-height: 60px;
    // padding: 10px;
    overflow: hidden;
    display: flex;
    position: relative;
  }
  
  .struct-tree-ifc,
  .struct-tree-process {
    .struct-tree-filter {
      // height: auto;
      width: 100%;
      margin-bottom: 5px;
      display: flex;
      position: relative;
      align-items: stretch;
      height: 25px;
  
  
      .struct-tree-filter-btn {
        height: 25px;
        max-width: 50px;
  
        margin: 0 5px 0 5px;
      }
  
      .input_search {
        display: flex;
        position: relative;
        align-items: stretch;
        min-width: 20px;
        height: 100%;
        width: 100%;
        max-width: auto;
      }
  
      // Damit Buttons gewünscht klein bleiben
      .v-btn:not(.v-btn--round).v-size--default {
        height: none;
        min-width: 0;
        padding: none;
      }
  
      .struct-tree-filter-search {
        max-height: 26px;
        width: auto;
        min-width: 50px;
        // max-width: 250px;
        margin: 0 5px 0 5px;
        padding-left: 2px;
      }
    }
  
  
  
    .struct-tree-ifc-content,
    .struct-tree-process-content {
      display: flex;
      align-items: stretch;
      align-self: flex-start;
      position: relative;
      overflow: hidden;
      overflow-y: scroll;
      overflow-x: unset;
      height: 100%;
      width: 100%;
      // height: auto;
      // width: auto;
      // min-height: 200px;
      // min-width: 200px;
      // max-height: 100%;
      // max-width: 100%;
  
      // align-items: flex-start;
      // justify-content: flex-start;
      // position: relative;
      // align-self: flex-start; 
      // min-height: 200px;
      // width: 100%;
      // width: auto;
      // height: 100%;
      // padding: 5px;
      // resize: both;
      // overflow:hidden;
  
    }
  }
  
  
  
  .hp-side-button {
    height: 30px;
    width: 30px;
    min-width: 35px;
    margin: 2px;
  }
  
  // content area
  .struct-content-center {
    //  height: 100vh;
    //  width: 100vw;
    height: 100%;
    width: 100%;
  
  }
  
  .struct-content-top,
  .struct-btn-side {
    //  height: 100vh;
    //  width: 100vw;
    height: 100%;
    width: 100%;
  
  }
  
  .struct-content-left,
  .struct-content-right {
    //  height: 100vh;
    //  width: 100vw;
    height: 100%;
    width: 100%;
    // max-height: auto;
    // max-width: auto;
    min-width: 285px;
    max-width: 500px;
    // padding: 10px;
    overflow: hidden;
    display: flex;
    position: relative;
  }
  
  .struct-content-left-ifc,
  .struct-content-right-process {
    //  height: 100vh;
    //  width: 100vw;
    height: 100%;
    width: 100%;
    // max-height: auto;
    // max-width: auto;
    min-width: 265px;
    padding: 10px;
  }
  
  // Content Specific
  .struct-tree {
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;
    align-self: flex-start;
    // background-color: #53528A;
    min-height: 200px;
    border-radius: 4px;
    // width: 100%;
    width: 100%;
    height: 100%;
    margin-bottom: 4px;
    padding: 10px 5px;
    // resize: both;
    // overflow:hidden;
  }
  
  .projectTree {
    width: 100%;
  }
  
  
  
  .struct-details {
    align-items: flex-end;
    justify-content: flex-end;
    position: relative;
    // align-self: flex-start;  
    // background-color: red;
    min-height: 225px;
    width: 100%;
    height: 100%;
    // max-height: auto;
    margin-top: 5px;
    overflow: hidden;
  
  }
  
  // Detail Style Settings
  #list_geometry {
    list-style-type: none;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-count: 2;
    column-gap: 10px;
  }
  
  .list_detail {
    list-style-type: none;
  }
  
  .detail_list_view {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-count: 2;
    column-gap: 10px;
  }
  
  .grid_space {
    height: 20px;
  }
  
  .struct-details-ifc,
  .struct-details-process {
    // align-items: flex-end;
    // justify-content: flex-end;
    position: relative;
    // background-color: red;
    min-height: 200px;
    width: 100%;
    height: 100%;
    // padding: 10px 5px;
    border-radius: 4px;
    // max-height: auto;
    display: flex;
    align-items: stretch;
    align-self: flex-start;
  }
  
  
  
  .struct-slider {
    height: 10px;
    width: 100%;
    background-color: #53528A;
    margin-bottom: 5px;
  }
  
  .struct-slider-x {
    height: 100%;
    width: 10px;
    background-color: #53528A;
    // margin-left: 5px;
  }
  
  .selectBox {
    border: 1px solid #55aaff;
    background-color: rgba(75, 160, 255, 0.3);
    position: fixed;
  }</style>
  